var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _path25, _g23, _path26, _g24, _path27, _g25, _path28, _g26, _path29, _g27, _path30, _g28, _path31, _g29, _path32, _g30, _path33, _g31, _path34, _g32, _path35, _g33, _path36, _g34, _path37, _g35, _path38, _g36, _path39, _g37, _path40, _g38, _path41, _g39, _path42, _g40, _path43, _g41, _path44, _g42, _path45, _g43, _path46, _g44, _path47, _g45, _path48, _g46, _path49, _g47, _path50, _g48, _path51, _g49, _path52, _g50, _path53, _g51, _path54, _g52, _path55, _g53, _path56, _g54, _path57, _g55, _path58, _g56, _path59, _g57, _path60, _g58, _path61, _g59, _path62, _g60, _path63, _g61, _path64, _g62, _path65, _g63, _path66, _g64, _path67, _g65, _path68, _g66, _path69, _g67, _path70, _g68, _path71, _g69, _path72, _g70, _path73, _g71, _path74, _g72, _path75, _g73, _path76, _g74, _path77, _g75, _path78, _g76, _path79, _g77, _path80, _g78, _path81, _g79, _path82, _g80, _path83, _g81, _path84, _g82, _path85, _g83, _path86, _g84, _path87, _g85, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g86, _path95, _g87, _path96, _g88, _path97, _g89, _path98, _g90, _path99, _g91, _path100, _g92, _path101, _g93, _path102, _g94, _path103, _g95, _path104, _g96, _path105, _g97, _path106, _g98, _path107, _g99, _path108, _g100, _path109, _g101, _path110, _g102, _path111, _g103, _path112, _g104, _path113, _g105, _path114, _g106, _path115, _g107, _path116, _g108, _path117, _g109, _path118, _g110, _path119, _g111, _path120, _g112, _path121, _g113, _path122, _g114, _path123, _g115, _path124, _g116, _path125, _g117, _path126, _g118, _path127, _g119, _path128, _g120, _path129, _g121, _path130, _g122, _path131, _g123, _path132, _g124, _path133, _g125, _path134, _g126, _path135, _g127, _path136, _g128, _path137, _g129, _path138, _g130, _path139, _g131, _path140, _g132, _path141, _g133, _path142, _g134, _path143, _g135, _path144, _g136, _path145, _g137, _path146, _g138, _path147, _g139, _path148, _g140, _path149, _g141, _path150, _g142, _path151, _g143, _path152, _g144, _path153, _g145, _path154, _g146, _path155, _g147, _path156, _g148, _path157, _g149, _path158, _g150, _path159, _g151, _path160, _g152, _path161, _g153, _path162, _g154, _path163, _g155, _path164, _g156, _path165, _g157, _path166, _g158, _path167, _g159, _path168, _g160, _path169, _g161, _path170, _g162, _path171, _g163, _path172, _g164, _path173, _g165, _path174, _g166, _path175, _g167, _path176, _g168, _path177, _g169, _path178, _g170, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _g171, _path208, _path209, _g172, _path210, _path211, _g173, _path212, _path213, _g174, _path214, _path215, _g175, _path216, _path217, _g176, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 106,
    viewBox: "0 0 123 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_51438)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.419 60.5369C18.9549 60.2401 19.5519 60.3874 20.1263 60.2268C20.4476 60.1386 20.6088 60.2133 20.8983 60.0565C21.1547 59.9126 21.4319 60.0444 21.6987 60.0223C21.9736 60.0002 22.1707 59.891 22.4317 59.8286C22.7409 59.7525 22.9553 59.8023 23.2359 59.8648C22.5561 59.1506 21.8754 58.4192 21.1301 57.782C20.8414 57.5354 20.5779 57.2659 20.3163 56.9883C20.1686 56.8262 20.0149 56.6702 19.8551 56.5181C19.7902 56.4543 19.4161 56.2382 19.5656 56.2263C18.7439 56.2976 18.4959 55.0213 19.3296 54.9501C20.1072 54.8804 20.6771 55.4953 21.1792 56.015C21.6833 56.5409 22.2408 57.0077 22.756 57.5185C22.8361 57.1027 22.9613 56.6922 23.0481 56.3459C23.2719 55.4191 22.9489 54.2972 23.6723 53.5723C24.2626 52.9793 25.1137 53.9623 24.5274 54.5474C24.3904 54.6832 24.4915 55.1537 24.4948 55.3267C24.5032 55.6788 24.4193 56.0463 24.3526 56.3908C24.2838 56.7514 24.187 57.1018 24.1332 57.4695C24.0836 57.781 23.879 58.2421 24.0442 58.519C24.1348 58.6755 24.1451 58.8255 24.1135 58.955C24.2702 59.1041 24.431 59.2511 24.5868 59.4011C24.7136 59.5258 24.8274 59.6554 24.9361 59.786C24.9361 59.786 24.9381 59.788 24.9411 59.789C25.2265 59.8887 25.3538 60.115 25.3618 60.3494C25.4963 60.5365 25.6269 60.7276 25.7705 60.9097C26.0147 61.2304 26.7306 61.2801 27.0941 61.4005C27.761 61.6227 28.39 61.7904 29.0887 61.861C29.5659 61.9088 30.1324 61.9382 30.5616 62.1698C31.2499 62.5431 31.9015 62.388 32.6463 62.4549C33.8412 62.5645 35.0057 62.9846 36.123 63.4053C37.3565 63.8692 38.5606 64.3963 39.7758 64.9063C40.6226 65.2647 41.7762 65.4272 42.425 66.1221C42.9939 66.7359 42.0213 67.5896 41.4544 66.9779C41.2059 66.7074 40.7078 66.6343 40.3693 66.5271C39.8535 66.3694 39.3581 66.1333 38.8647 65.9214C37.7386 65.4412 36.6164 64.9732 35.4751 64.5401C34.3878 64.1317 33.1994 63.6892 32.0278 63.7328C31.435 63.7575 30.9497 63.7297 30.3921 63.5194C29.8324 63.307 29.3556 63.1887 28.7571 63.1289C27.6965 63.0224 26.7428 62.5837 25.7108 62.3547C25.0476 62.211 24.6101 61.5871 24.1955 61.0006C23.8965 61.0426 23.5358 61.1857 23.2851 61.1879C23.0093 61.1868 22.8817 61.0209 22.6383 61.1639C22.4513 61.2752 22.1475 61.2679 21.9387 61.2945C21.7471 61.3162 21.4315 61.2424 21.2636 61.3347C21.0384 61.4597 20.8284 61.5437 20.5638 61.5236C20.3392 61.5078 20.1996 61.548 19.9687 61.6006C19.6455 61.6706 19.285 61.5392 18.9915 61.6999C18.2565 62.1058 17.6921 60.9368 18.419 60.5369Z",
    fill: "#67472D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9161 33.3455C94.327 33.5122 94.0055 34.0379 93.4844 34.3285C93.1941 34.4923 93.1318 34.659 92.8159 34.7516C92.5327 34.8299 92.4279 35.1191 92.2226 35.2915C92.0116 35.4696 91.7949 35.5308 91.5655 35.6704C91.2921 35.8343 91.1746 36.0209 91.0188 36.2631C91.0018 35.2758 90.9735 34.2758 91.0571 33.2971C91.0896 32.9181 91.0882 32.5406 91.0797 32.1588C91.0712 31.9395 91.0712 31.7201 91.0783 31.4993C91.0797 31.4081 91.1944 30.9907 91.0797 31.0876C91.7142 30.559 90.9962 29.4764 90.3532 30.0134C89.7513 30.512 89.7768 31.3511 89.7839 32.0748C89.7938 32.8042 89.7244 33.5293 89.7159 34.2558C89.3676 34.0165 88.9908 33.8128 88.6864 33.6276C87.8777 33.1261 87.3212 32.1004 86.2987 32.0947C85.4632 32.089 85.5467 33.3882 86.3738 33.3911C86.5664 33.3911 86.8241 33.7971 86.9431 33.9225C87.1838 34.1789 87.501 34.3812 87.7899 34.5792C88.0916 34.7872 88.406 34.9681 88.7019 35.1918C88.9554 35.3784 89.4242 35.5622 89.5007 35.8756C89.546 36.0508 89.6437 36.1648 89.757 36.2346C89.7499 36.4511 89.7386 36.6691 89.7329 36.8856C89.7301 37.0637 89.74 37.236 89.7542 37.4056C89.7542 37.4056 89.7542 37.4084 89.7528 37.4113C89.6196 37.6834 89.6876 37.9341 89.8462 38.1065C89.8816 38.3344 89.9227 38.5623 89.9482 38.7931C89.9992 39.1934 89.5247 39.7333 89.3506 40.0752C89.0319 40.7035 88.7019 41.2662 88.2544 41.8089C87.9485 42.1793 87.5662 42.5996 87.4231 43.0668C87.1951 43.8176 86.623 44.1666 86.1401 44.7393C85.3669 45.6596 84.833 46.7793 84.333 47.8663C83.7807 49.0658 83.2936 50.2895 82.7866 51.5089C82.4354 52.3608 81.7287 53.2896 81.7542 54.2413C81.7797 55.0789 83.0698 55.0006 83.0443 54.1658C83.0316 53.7982 83.3346 53.3951 83.5003 53.0802C83.7567 52.6044 83.9436 52.0873 84.1461 51.5887C84.6106 50.4533 85.0808 49.3293 85.5892 48.2167C86.0764 47.1597 86.6117 46.0072 87.4755 45.2123C87.9146 44.812 88.2403 44.4501 88.4895 43.9074C88.7388 43.3617 88.9951 42.9415 89.3789 42.4771C90.0586 41.6537 90.4297 40.6693 91.0032 39.7789C91.3743 39.2091 91.2482 38.4569 91.1321 37.7475C91.3743 37.5665 91.7312 37.4141 91.911 37.2389C92.1064 37.0437 92.0809 36.8357 92.3543 36.7659C92.5653 36.7132 92.7763 36.4938 92.9434 36.3656C93.0949 36.246 93.2677 35.971 93.4518 35.9183C93.6996 35.8485 93.9078 35.7602 94.082 35.5593C94.2307 35.3898 94.3582 35.32 94.5593 35.1946C94.8382 35.0165 95.0025 34.6689 95.324 34.5763C96.1312 34.347 95.7134 33.1176 94.9161 33.3455Z",
    fill: "#67472D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4528 19.8789L104.815 27.0175L95.7488 109.686L31.3864 102.543L40.4528 19.8789Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6188 100.365C33.9482 91.8331 25.7996 63.823 36.4152 37.8059C41.7231 24.7952 50.7172 14.7476 60.9689 9.01938L59.7878 19.7921L105.135 24.8251L106.117 15.8659C109.622 20.0983 112.247 25.2112 113.893 30.871L106.696 30.0718L102.565 67.742L111.266 68.7079C100.647 94.7278 75.2879 108.901 54.6188 100.365Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6754 100.222C34.0686 91.7163 25.944 63.7902 36.5271 37.8529C41.8194 24.8835 50.7852 14.8644 61.0057 9.15186L59.8388 19.7977L105.053 24.8137L106.022 15.977C109.515 20.1981 112.133 25.2952 113.777 30.938L106.69 30.153L102.572 67.7092L111.153 68.6609C100.568 94.5996 75.2822 108.734 54.6754 100.222Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7349 100.08C34.1904 91.5966 26.0899 63.7589 36.6418 37.8999C41.9171 24.9675 50.8574 14.9812 61.0482 9.2886L59.8955 19.8034L104.968 24.8066L105.924 16.0924C109.408 20.2963 112.016 25.3821 113.654 31.0063L106.682 30.2328L102.576 67.675L111.041 68.6153C100.486 94.4771 75.2766 108.563 54.7349 100.08Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.793 99.9389C34.3108 91.4798 26.2372 63.7261 36.7551 37.9441C42.0148 25.053 50.9268 15.0981 61.085 9.41968L59.945 19.8091L104.883 24.7952L105.826 16.2064C109.297 20.3989 111.9 25.4662 113.53 31.0762L106.67 30.3168L102.576 67.6451L110.925 68.5711C100.408 94.3489 75.2737 108.394 54.793 99.9389Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8524 99.7936C34.4326 91.363 26.3802 63.6948 36.867 37.9911C42.1111 25.1414 50.9962 15.2149 61.1233 9.55502L59.9988 19.8134L104.8 24.7852L105.727 16.3161C109.188 20.4986 111.783 25.5502 113.41 31.1431L106.662 30.3952L102.58 67.6095L110.808 68.5227C100.326 94.2264 75.2723 108.224 54.8524 99.7936Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9119 99.6526C34.5544 91.249 26.5275 63.6648 36.9803 38.0395C42.2074 25.2268 51.067 15.3331 61.163 9.69034L60.0527 19.8234L104.713 24.7795L105.628 16.4329C109.081 20.6012 111.665 25.6371 113.285 31.2129L106.652 30.475L102.586 67.5739L110.699 68.4757C100.244 94.0982 75.2638 108.058 54.9119 99.6526Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9686 99.5102C34.6748 91.1322 26.6705 63.6307 37.0964 38.0837C42.308 25.3123 51.1392 15.4457 61.2012 9.82285L60.1051 19.8277L104.631 24.7667L105.533 16.5454C108.973 20.6995 111.549 25.7212 113.166 31.2785L106.645 30.5548L102.589 67.544L110.585 68.4287C100.163 93.9728 75.261 107.888 54.9686 99.5102Z",
    fill: "#F9FBFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0252 99.3677C34.7951 91.0154 26.8178 63.5979 37.2083 38.1307C42.4042 25.402 51.2086 15.5653 61.2408 9.95959L60.1575 19.8348L104.548 24.7596L105.437 16.6565C108.865 20.7992 111.434 25.8052 113.046 31.3482L106.638 30.6388L102.595 67.5084L110.471 68.3816C100.081 93.8474 75.2582 107.721 55.0252 99.3677Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0833 99.2238C34.9155 90.8957 26.9636 63.5651 37.323 38.1805C42.5005 25.4847 51.278 15.6793 61.2805 10.0892L60.2113 19.8391L104.463 24.7496L105.336 16.7705C108.755 20.8989 111.318 25.8907 112.926 31.4138L106.626 30.7157L102.596 67.4742L110.358 68.3332C99.9988 93.7221 75.2525 107.553 55.0833 99.2238Z",
    fill: "#F7FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1428 99.0814C35.0373 90.7789 27.1081 63.5338 37.4349 38.2275C42.5997 25.5744 51.3488 15.7961 61.3201 10.2231L60.2651 19.8448L104.376 24.7382L105.237 16.8831C108.647 20.9987 111.201 25.9762 112.804 31.4822L106.618 30.7969L102.6 67.4371L110.243 68.2862C99.9181 93.5953 75.2468 107.381 55.1428 99.0814Z",
    fill: "#F6FAFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2022 98.9375C35.1577 90.6649 27.254 63.5039 37.5496 38.2731C42.6974 25.6585 51.4182 15.9143 61.3598 10.3599L60.3189 19.8504L104.294 24.7311L105.142 16.9984C108.54 21.1027 111.085 26.0573 112.683 31.5505L106.612 30.8767L102.606 67.4072L110.132 68.242C99.8359 93.4699 75.244 107.214 55.2022 98.9375Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2603 98.7979C35.2795 90.5481 27.3998 63.4697 37.6629 38.3201C42.7937 25.7439 51.4876 16.0311 61.3966 10.4938L60.3699 19.8561L104.209 24.7225L105.043 17.1096C108.431 21.2024 110.968 26.1471 112.562 31.6175L106.601 30.9551L102.609 67.3702L110.018 68.1936C99.7552 93.3446 75.2412 107.048 55.2603 98.7979Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.317 98.6525C35.3998 90.4313 27.5457 63.4398 37.7748 38.3671C42.8914 25.8323 51.5584 16.1465 61.4363 10.6263L60.4223 19.8604L90.6775 23.2182L92.3628 7.86118C112.281 16.0824 120.133 43.0754 109.904 68.1466C99.6731 93.2192 75.2327 106.878 55.317 98.6525Z",
    fill: "#F3F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3736 98.5116C35.5202 90.3117 27.6916 63.4056 37.8895 38.4113C42.9891 25.9163 51.6278 16.2634 61.4745 10.7631L60.4761 19.8676L90.635 23.2153L92.3033 8.00366C112.16 16.2007 119.991 43.1053 109.792 68.1024C99.5909 93.0939 75.2298 106.709 55.3736 98.5116Z",
    fill: "#F2F7FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4331 98.3662C35.6406 90.1948 27.836 63.3757 38.0028 38.4598C43.0854 26.0032 51.6986 16.3816 61.5127 10.8941L60.5285 19.8761L90.5925 23.2125L92.2452 8.14468C112.039 16.3189 119.842 43.1381 109.68 68.0554C99.5102 92.9656 75.227 106.539 55.4331 98.3662Z",
    fill: "#F1F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4925 98.2252C35.7624 90.078 27.9833 63.3415 38.1146 38.5068C43.1817 26.0915 51.768 16.5013 61.5538 11.0309L60.5823 19.8818L90.5514 23.2068L92.1885 8.28998C111.919 16.4372 119.698 43.1723 109.564 68.0084C99.4309 92.8431 75.2213 106.371 55.4925 98.2252Z",
    fill: "#F0F6F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5506 98.0827C35.8828 89.964 28.1264 63.3087 38.228 38.5538C43.2766 26.177 51.836 16.6152 61.5906 11.1634L60.6333 19.8861L90.5104 23.1997L92.1305 8.43103C111.797 16.5526 119.551 43.2022 109.452 67.96C99.3488 92.7149 75.2157 106.201 55.5506 98.0827Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6101 97.9403C36.0045 89.8472 28.2736 63.2774 38.3426 38.6008C43.3772 26.2611 51.9082 16.7306 61.6317 11.2973L60.6899 19.8918L90.4679 23.1968L92.0724 8.57349C111.677 16.668 119.407 43.2364 109.337 67.913C99.268 92.591 75.2142 106.035 55.6101 97.9403Z",
    fill: "#EEF5F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6668 97.7964C36.1235 89.7276 28.4209 63.2475 38.4531 38.6478C43.4735 26.3466 51.9776 16.8474 61.6699 11.4298L60.7423 19.8961L90.4268 23.1911L92.0144 8.71594C111.555 16.7848 119.262 43.2677 109.222 67.8674C99.1859 92.4656 75.21 105.865 55.6668 97.7964Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7234 97.6539C36.2439 89.6107 28.5639 63.2132 38.5707 38.6962C43.5712 26.4334 52.0484 16.9657 61.7096 11.5651L60.7947 19.9046L90.3829 23.1882L91.9549 8.8598C111.434 16.903 119.116 43.3005 109.112 67.8189C99.1066 92.3402 75.2043 105.699 55.7234 97.6539Z",
    fill: "#ECF4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7829 97.51C36.3657 89.4939 28.7112 63.1834 38.6825 38.7433C43.6689 26.5232 52.1192 17.0825 61.7492 11.7004L60.8485 19.9089L90.3404 23.1811L91.8954 9.00229C111.313 17.0184 118.97 43.3318 108.997 67.7719C99.0259 92.2149 75.2001 105.529 55.7829 97.51Z",
    fill: "#EBF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8409 97.3676C36.486 89.38 28.8543 63.1506 38.7972 38.7874C43.7666 26.6058 52.19 17.1965 61.7861 11.8343L60.8995 19.9146L90.3008 23.1783L91.8388 9.14331C111.191 17.1352 118.821 43.3646 108.884 67.7263C98.9437 92.0867 75.1958 105.358 55.8409 97.3676Z",
    fill: "#E9F3F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9004 97.2251C36.6078 89.2603 29.0015 63.1192 38.9105 38.8344C43.8629 26.6927 52.2594 17.3133 61.8285 11.9683L60.9562 19.9231L90.2597 23.1726L91.7821 9.28577C111.07 17.252 118.68 43.3945 108.772 67.6793C98.863 91.9641 75.1902 105.189 55.9004 97.2251Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9585 97.0841C36.7282 89.1435 29.1474 63.0865 39.0224 38.8814C43.962 26.781 52.3288 17.4287 61.8654 12.1007L61.0071 19.9274L90.2158 23.1683L91.724 9.42822C110.951 17.366 118.535 43.423 108.656 67.6295C98.7809 91.8359 75.1859 105.022 55.9585 97.0841Z",
    fill: "#E7F2F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0165 96.9388C36.85 89.0267 29.2933 63.0523 39.1357 38.927C44.0583 26.8651 52.3982 17.5469 61.9036 12.2389L61.0596 19.9345L90.1733 23.1655L91.6646 9.57639C110.83 17.4899 118.388 43.4629 108.544 67.5867C98.7001 91.7106 75.1817 104.855 56.0165 96.9388Z",
    fill: "#E6F1F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0732 96.7978C36.9718 88.9099 29.4377 63.0224 39.2504 38.974C44.1546 26.9506 52.469 17.6637 61.9432 12.3686L61.1134 19.9402L90.1294 23.1598L91.6037 9.71884C110.708 17.6067 118.241 43.4942 108.428 67.5397C98.618 91.5852 75.1788 104.686 56.0732 96.7978Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1313 96.6553C37.0922 88.793 29.5836 62.9882 39.3623 39.021C44.2538 27.0403 52.5384 17.7834 61.9815 12.5053L61.1658 19.9459L90.0884 23.154L91.547 9.85986C110.588 17.7221 118.095 43.5227 108.316 67.4898C98.5359 91.4613 75.1732 104.516 56.1313 96.6553Z",
    fill: "#E4F0F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1907 96.5128C37.2139 88.6762 29.728 62.9583 39.477 39.0709C44.3487 27.1229 52.6078 17.9002 62.0211 12.6378L61.2196 19.9502L90.0487 23.1498L91.4904 10.0009C110.469 17.839 117.952 43.5569 108.207 67.4429C98.4551 91.3331 75.1675 104.347 56.1907 96.5128Z",
    fill: "#E3EFF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2502 96.3689C37.3329 88.558 29.8753 62.9269 39.5903 39.115C44.4464 27.2098 52.6786 18.0142 62.0594 12.7717L61.272 19.9559L90.0062 23.1441L91.4309 10.1448C110.347 17.9515 117.804 43.5868 108.088 67.3973C98.373 91.2105 75.1647 104.178 56.2502 96.3689Z",
    fill: "#E2EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3083 96.2265C37.4547 88.4412 30.0198 62.8942 39.7036 39.1635C44.5455 27.2996 52.7494 18.131 62.0976 12.9085L61.3244 19.9616L89.9638 23.1384L91.3729 10.2873C110.226 18.0726 117.66 43.621 107.975 67.3517C98.2923 91.0823 75.159 104.012 56.3083 96.2265Z",
    fill: "#E1EEF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3649 96.0826C37.5751 88.3244 30.1671 62.8628 39.8169 39.2105C44.6418 27.3822 52.8188 18.2478 62.1387 13.0395L61.3796 19.9673L89.9213 23.137L91.3134 10.4297C110.106 18.1894 117.513 43.6509 107.864 67.3047C98.2116 90.957 75.1548 103.842 56.3649 96.0826Z",
    fill: "#E0EDF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4216 95.9401C37.6969 88.2075 30.3101 62.83 39.9288 39.2547C44.7395 27.4677 52.8868 18.3646 62.1755 13.172L61.4306 19.9744L89.8788 23.1298L91.2553 10.5736C109.984 18.3034 117.367 43.6837 107.748 67.2591C98.1323 90.8316 75.152 103.673 56.4216 95.9401Z",
    fill: "#DFEDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4811 95.7991C37.8173 88.0935 30.4574 62.7987 40.0435 39.3017C44.8387 27.5546 52.9604 18.4814 62.218 13.3088L61.4858 19.9815L89.8363 23.1256L91.1972 10.716C109.865 18.4202 117.222 43.715 107.636 67.212C98.0501 90.7034 75.1491 103.506 56.4811 95.7991Z",
    fill: "#DEECF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5405 95.6566C37.9376 87.9739 30.6047 62.7659 40.1582 39.3501C44.935 27.6415 53.0298 18.5997 62.2562 13.4427L61.5382 19.9872L89.7952 23.1227L91.1406 10.8585C109.744 18.5384 117.078 43.7492 107.523 67.165C97.968 90.5809 75.1435 103.337 56.5405 95.6566Z",
    fill: "#DDECF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5986 95.5114C38.058 87.8571 30.7505 62.7332 40.2701 39.3971C45.0313 27.7298 53.0992 18.7151 62.2959 13.5795L61.5921 19.9929L89.7556 23.117L91.0854 10.9995C109.623 18.6567 116.933 43.782 107.41 67.1152C97.8859 90.4541 75.1378 103.168 56.5986 95.5114Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6581 95.3703C38.1798 87.7403 30.895 62.7018 40.3862 39.4441C45.1304 27.8139 53.1686 18.8319 62.3327 13.7091L61.643 19.9972L89.7117 23.1099L91.0245 11.1434C109.501 18.7735 116.785 43.8119 107.296 67.0696C97.808 90.3316 75.1349 102.999 56.6581 95.3703Z",
    fill: "#DBEBF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7147 95.225C38.3002 87.6235 31.038 62.6691 40.4981 39.4912C45.2267 27.8993 53.2408 18.9487 62.3738 13.843L61.6968 20.0029L89.6678 23.1085L90.9636 11.2859C109.378 18.8903 116.637 43.8418 107.182 67.0226C97.7258 90.2034 75.1293 102.829 56.7147 95.225Z",
    fill: "#DAEAF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7714 95.084C38.4219 87.5066 31.1853 62.6377 40.6114 39.5382C45.323 27.9891 53.3102 19.0655 62.412 13.9798L61.7506 20.0086L89.6253 23.1028L90.9055 11.4283C109.256 19.0071 116.494 43.876 107.067 66.9756C97.6437 90.078 75.1236 102.66 56.7714 95.084Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8308 94.9415C38.5409 87.3898 31.3311 62.6078 40.7247 39.5837C45.4221 28.0731 53.3796 19.1809 62.4502 14.1137L61.803 20.0157L89.5828 23.0985L90.8474 11.5708C109.137 19.1254 116.351 43.9074 106.956 66.9314C97.5629 89.9526 75.1208 102.493 56.8308 94.9415Z",
    fill: "#D8E9EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8889 94.7991C38.6613 87.273 31.4784 62.5736 40.8366 39.6308C45.517 28.1586 53.4476 19.2977 62.4871 14.2476L61.854 20.0214L89.5432 23.0956L90.7908 11.7161C109.017 19.2422 116.204 43.9415 106.843 66.8858C97.4808 89.8273 75.118 102.324 56.8889 94.7991Z",
    fill: "#D7E8EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9484 94.6552C38.7831 87.1562 31.6215 62.5437 40.9513 39.6778C45.6147 28.2455 53.5198 19.4131 62.5281 14.3829L61.9093 20.0285L89.5007 23.0885L90.7327 11.8586C108.895 19.3575 116.057 43.9715 106.727 66.836C97.4001 89.6991 75.1109 102.156 56.9484 94.6552Z",
    fill: "#D6E8EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0079 94.5127C38.9049 87.0394 31.7673 62.5095 41.0645 39.7248C45.711 28.331 53.5906 19.5299 62.5664 14.514L61.9617 20.0342L89.4582 23.0843L90.6733 12.0024C108.772 19.4758 115.91 44.0028 106.617 66.7904C97.318 89.5737 75.1066 101.989 57.0079 94.5127Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0645 94.3688C39.0253 86.9225 31.9132 62.4767 41.1764 39.7689C45.8102 28.4193 53.66 19.6467 62.606 14.6493L62.0141 20.0385L89.4157 23.08L90.6166 12.1392C108.653 19.5869 115.768 44.037 106.502 66.7405C97.2373 89.4483 75.1038 101.817 57.0645 94.3688Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4639 93.3916C39.8537 86.1219 32.9116 62.2602 41.9553 40.0923C51.0004 17.9273 72.6085 5.85253 90.2158 13.1222C107.823 20.3918 114.768 44.2535 105.723 66.4214C96.6821 88.5865 75.074 100.663 57.4639 93.3916Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8647 92.4129C40.6822 85.3199 33.91 62.038 42.7328 40.4157C51.5556 18.7877 72.6368 7.00643 89.815 14.1023C106.995 21.1952 113.77 44.4743 104.947 66.0994C96.1213 87.7246 75.0429 99.5073 57.8647 92.4129Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.264 91.4328C41.5135 84.5193 34.9084 61.82 43.5103 40.7348C52.115 19.6496 72.6666 8.16461 89.4185 15.0809C106.166 21.9944 112.773 44.6937 104.168 65.7789C95.5676 86.8641 75.0118 98.3505 58.264 91.4328Z",
    fill: "#E0EDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6605 90.4569C42.3419 83.7172 35.9082 61.6006 44.2892 41.0553C52.6701 20.5129 72.6977 9.3228 89.0177 16.0611C105.338 22.8008 111.776 44.9145 103.391 65.4598C95.0082 86.0023 74.982 97.1952 58.6605 90.4569Z",
    fill: "#E3EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0627 89.4768C43.169 82.9166 36.9066 61.3798 45.0666 41.3773C53.2281 21.3719 72.7289 10.4739 88.6184 17.0369C104.509 23.6 110.774 45.1339 102.614 65.1364C94.4516 85.139 74.9537 96.037 59.0627 89.4768Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4593 88.4981C44.0003 82.1132 37.9008 61.1604 45.8413 41.6978C53.7846 22.238 72.7572 11.6335 88.2176 18.017C103.681 24.402 109.777 45.3533 101.834 64.8159C93.895 84.2799 74.9211 94.8802 59.4593 88.4981Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8601 87.518C44.8302 81.3111 38.9006 60.941 46.6216 42.0212C54.3426 23.0956 72.7869 12.7888 87.8197 18.9943C102.852 25.2012 108.779 45.5741 101.058 64.4954C93.3371 83.4166 74.8928 93.7249 59.8601 87.518Z",
    fill: "#EAF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2594 86.5394C45.6572 80.512 39.899 60.7217 47.4005 42.3417C54.9006 23.9604 72.8152 13.9441 87.4203 19.973C102.025 26.0018 107.781 45.7935 100.282 64.1734C92.7805 82.5548 74.8616 92.5682 60.2594 86.5394Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6588 85.5592C46.4857 79.7085 40.896 60.5037 48.1752 42.6608C55.4557 24.8208 72.8478 15.1009 87.0209 20.9531C101.194 26.8038 106.782 46.0115 99.5031 63.8543C92.2226 81.6915 74.8333 91.41 60.6588 85.5592Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0581 84.5805C47.3141 78.9079 41.8944 60.2815 48.9541 42.9842C56.0151 25.6827 72.8776 16.2591 86.623 21.9346C100.364 27.6044 105.782 46.2308 98.7242 63.5309C91.6688 80.8325 74.8036 90.2561 61.0581 84.5805Z",
    fill: "#F0F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4575 83.6033C48.144 78.1058 42.8942 60.0649 49.7344 43.3033C56.5703 26.5417 72.9073 17.413 86.2222 22.9133C99.5371 28.4051 104.785 46.4488 97.9496 63.2104C91.108 79.9692 74.7724 89.1007 61.4575 83.6033Z",
    fill: "#F2F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8583 82.6232C48.9711 77.3038 43.8927 59.8441 50.5104 43.6253C57.1297 27.4036 72.937 18.5698 85.8243 23.8906C98.7072 29.2071 103.787 46.6696 97.1707 62.8885C90.5529 79.1102 74.7413 87.944 61.8583 82.6232Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2562 81.6445C49.7995 76.5032 44.8896 59.6248 51.2865 43.9458C57.6848 28.2669 72.9682 19.7251 85.4221 24.8678C97.8774 30.012 102.79 46.8904 96.3932 62.5694C89.9963 78.2469 74.7115 86.7887 62.2562 81.6445Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6556 80.6672C50.628 75.7011 45.888 59.4039 52.0654 44.2649C58.2399 29.1288 72.9979 20.8819 85.0227 25.8451C97.046 30.8112 101.789 47.1084 95.6143 62.2474C89.4369 77.385 74.6832 85.6319 62.6556 80.6672Z",
    fill: "#F6FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0564 79.6857C51.4593 74.9005 46.8879 59.1845 52.8443 44.5883C58.7993 29.9892 73.0291 22.04 84.6248 26.8252C96.2204 31.6132 100.795 47.3278 94.8368 61.9254C88.8818 76.5217 74.6535 84.4737 63.0564 79.6857Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4557 78.7056C52.2878 74.0985 47.8863 58.9651 53.6204 44.9074C59.3559 30.8525 73.0574 23.1954 84.2254 27.8053C95.392 32.4181 99.7963 47.5486 94.0593 61.6063C88.3224 75.6641 74.6223 83.3198 63.4557 78.7056Z",
    fill: "#F9FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8551 77.7297C53.1162 73.295 48.8847 58.7458 54.3993 45.2308C59.9139 31.7144 73.0872 24.3521 83.8246 28.7854C94.5635 33.2202 98.7979 47.7694 93.2819 61.283C87.7687 74.7994 74.5912 82.1645 63.8551 77.7297Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2516 76.7496C53.9475 72.493 49.8845 58.525 55.1753 45.5513C60.4676 32.5777 73.1183 25.5075 83.4252 29.7641C93.7336 34.0208 97.798 47.9888 92.5029 60.9624C87.2093 73.9375 74.5628 81.0049 64.2516 76.7496Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6538 75.7709C54.7746 71.6924 50.8801 58.3056 55.9528 45.8718C61.0284 33.4395 73.1495 26.6656 83.0273 30.7442C92.9066 34.8228 96.8011 48.2096 91.7255 60.6433C86.6541 73.0742 74.5317 79.8495 64.6538 75.7709Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0518 74.7908C55.6045 70.8932 51.8785 58.0848 56.7331 46.1938C61.585 34.2985 73.1778 27.8195 82.6265 31.72C92.0781 35.6205 95.8027 48.4261 90.9494 60.3199C86.0933 72.2152 74.5019 78.6956 65.0518 74.7908Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4539 73.815C56.4329 70.0897 52.8769 57.8668 57.5092 46.5143C62.1415 35.1619 73.2089 28.9763 82.2286 32.7002C91.2468 36.4226 94.8028 48.6484 90.1705 60.0008C85.5396 71.3519 74.4693 77.5374 65.4539 73.815Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8519 72.8349C57.2614 69.2905 53.8725 57.6489 58.2853 46.8334C62.6981 36.0209 73.2387 30.1331 81.8278 33.6789C90.4169 37.2232 93.803 48.8649 89.3916 59.6803C84.9816 70.4929 74.441 76.3835 65.8519 72.8349Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2498 71.8562C58.0884 68.4871 54.8709 57.4295 59.0642 47.1568C63.256 36.8842 73.267 31.2856 81.4284 34.659C89.5899 38.0281 92.806 49.0857 88.617 59.3583C84.4237 69.6296 74.4113 75.2253 66.2498 71.8562Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6506 70.8761C58.9197 67.685 55.8721 57.2058 59.8416 47.4759C63.8126 37.746 73.2996 32.4452 81.0291 35.6348C88.7586 38.8287 91.8062 49.3051 87.8381 59.0378C83.8671 68.7677 74.383 74.0686 66.6506 70.8761Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0486 69.8974C59.7482 66.8844 56.8705 56.9907 60.6191 47.7993C64.3692 38.6093 73.3293 33.6005 80.6297 36.6135C87.9301 39.6293 90.8106 49.5245 87.0592 58.7145C83.3091 67.9044 74.3504 72.9132 67.0486 69.8974Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4494 68.9173C60.5767 66.0824 57.8675 56.7699 61.398 48.1184C64.9286 39.4669 73.3577 34.7544 80.2332 37.595C87.1031 40.4299 89.8136 49.7424 86.2845 58.3911C82.7554 67.0454 74.3207 71.7593 67.4494 68.9173Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8473 67.9414C61.4051 65.2818 58.8659 56.5505 62.1741 48.4404C65.4823 40.3331 73.3888 35.914 79.8296 38.5737C86.2732 41.2334 88.8138 49.9647 85.5056 58.0748C82.1946 66.1821 74.2909 70.5983 67.8473 67.9414Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2495 66.9613C62.2364 64.4769 59.8657 56.3297 62.953 48.7623C66.0431 41.1907 73.4214 37.0708 79.4345 39.5524C85.4462 42.0369 87.8197 50.1841 84.7267 57.7514C81.6395 65.3231 74.2626 69.4444 68.2495 66.9613Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6474 65.9827C63.0663 63.6763 60.8641 56.1103 63.7305 49.0829C66.5968 42.0568 73.4483 38.2261 79.0323 40.5325C84.6162 42.8389 86.8184 50.4049 83.9506 57.4323C81.0829 64.4584 74.23 68.2891 68.6474 65.9827Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0468 65.0025C63.8933 62.8742 61.8625 55.8923 64.5079 49.4048C67.1548 42.9158 73.478 39.3829 78.6343 41.5112C83.7892 43.6367 85.82 50.62 83.1732 57.1089C80.5249 63.5979 74.1989 67.1309 69.0468 65.0025Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4462 64.0267C64.7218 62.0764 62.8581 55.6715 65.284 49.7253C67.7128 43.7791 73.5078 40.5411 78.235 42.4885C82.9608 44.4387 84.8216 50.8408 82.3943 56.7898C79.967 62.736 74.1705 65.9741 69.4462 64.0267Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8455 63.0466C65.5503 61.2744 63.8565 55.4507 66.0629 50.0444C68.2693 44.6382 73.5375 41.695 77.8328 43.4672C82.128 45.2393 83.8218 51.063 81.6168 56.4693C79.4104 61.8756 74.1408 64.8188 69.8455 63.0466Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2463 62.0679C66.3787 60.4738 64.8549 55.2342 66.8432 50.3678C68.8273 45.5015 73.5715 42.8503 77.4362 44.4473C81.301 46.0414 82.8248 51.281 80.8393 56.1473C78.8552 61.0137 74.1111 63.662 70.2463 62.0679Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6428 61.0878C67.2086 59.6689 65.8547 55.0134 67.6165 50.6869C69.3824 46.3633 73.5998 44.0056 77.034 45.4259C80.4711 46.8448 81.825 51.5003 80.0604 55.824C78.2944 60.1504 74.0813 62.5067 70.6428 61.0878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.045 60.1091C68.0371 58.8683 66.8503 54.7926 68.3968 51.0103C69.9418 47.2266 73.6281 45.1624 76.6361 46.4061C79.6398 47.6469 80.8266 51.7212 79.2829 55.5049C77.7407 59.2885 74.0487 61.3528 71.045 60.1091Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.443 59.129C68.8655 58.0663 67.8487 54.5746 69.1742 51.3294C70.4955 48.0857 73.6579 46.3192 76.2325 47.3848C78.8099 48.4475 79.8267 51.9391 78.5054 55.1843C77.1799 58.4281 74.0204 60.1946 71.443 59.129Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8423 58.1531C69.694 57.2656 68.8485 54.3552 69.9503 51.6499C71.0535 48.9489 73.6919 47.4759 75.8374 48.3606C77.9843 49.2481 78.8298 52.1585 77.728 54.8638C76.6262 57.5662 73.9907 59.0378 71.8423 58.1531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2417 57.173C70.5239 56.4636 69.8469 54.1344 70.7292 51.9733C71.6129 49.8094 73.7202 48.6312 75.438 49.3407C77.1558 50.0501 77.8328 52.3765 76.9505 54.5404C76.0682 56.7029 73.9595 57.8825 72.2417 57.173Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6425 56.1943C71.3538 55.663 70.8454 53.915 71.5067 52.2967C72.1681 50.6712 73.7485 49.7894 75.0372 50.3208C76.326 50.8522 76.8344 52.6001 76.1744 54.2184C75.5103 55.8439 73.9298 56.7257 72.6425 56.1943Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0404 55.2142C72.1808 54.8581 71.8423 53.6956 72.2856 52.613C72.7246 51.5331 73.7783 50.9462 74.6379 51.2995C75.4975 51.6556 75.836 52.8181 75.3941 53.8979C74.9537 54.9806 73.9001 55.5675 73.0404 55.2142Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 23,
    width: 59,
    height: 80
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0581 46.9987C72.1851 43.4344 73.5092 38.5737 72.1525 33.9025C69.9815 26.4121 61.7436 22.2409 53.7577 24.5843C45.7691 26.9306 41.0532 34.9012 43.2242 42.3944C44.4634 46.6596 47.6738 49.8507 51.6816 51.3736C40.6595 57.9352 34.8758 70.7322 38.3979 82.8768C42.6209 97.4502 58.6492 105.567 74.1875 101.007C89.7287 96.4473 98.9012 80.9351 94.674 66.3616C91.3799 54.9892 80.8903 47.5457 69.0581 46.9987Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4398 54.2355C73.0121 54.0575 72.8422 53.4791 73.0617 52.9363C73.2812 52.3964 73.8094 52.1015 74.2385 52.2767C74.6704 52.4577 74.8404 53.036 74.618 53.5788C74.3957 54.1187 73.8689 54.4136 73.4398 54.2355Z",
    fill: "white"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5306 62.3841C73.0305 62.1505 73.1891 61.4553 72.8606 60.81C72.532 60.1646 71.8707 59.884 71.3934 60.1561C70.9133 60.431 70.8014 61.1077 71.1116 61.7146C71.4189 62.3158 72.0293 62.6192 72.5306 62.3841ZM72.2828 61.1433C72.2799 61.1319 72.2771 61.1205 72.2728 61.112C72.2658 61.0977 72.2573 61.0892 72.2488 61.0735C72.2643 61.0821 72.2771 61.0878 72.2828 61.0935C72.287 61.1049 72.2856 61.1248 72.2828 61.1433ZM71.6851 61.3798C71.6922 61.3912 71.6936 61.3998 71.6993 61.4069C71.7064 61.4211 71.7149 61.4325 71.7219 61.4453C71.705 61.4368 71.6922 61.4311 71.6894 61.4254C71.6851 61.4169 71.6823 61.3998 71.6851 61.3798Z",
    fill: "#67472D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2017 66.514C74.7965 66.3388 75.084 65.5823 74.8177 64.8031C74.5501 64.0238 73.8576 63.6036 73.2826 63.8344C72.7076 64.0651 72.4839 64.8031 72.7303 65.5268C72.9781 66.2519 73.6069 66.6892 74.2017 66.514Z",
    fill: "#67472D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4693 67.6651C73.8703 67.8161 73.5502 68.5141 73.6975 69.2592C73.849 70.0042 74.4141 70.5199 75.0259 70.4245C75.6377 70.3304 76.0243 69.621 75.8643 68.819C75.7 68.0198 75.0712 67.5155 74.4693 67.6651Z",
    fill: "#67472D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2185 71.9374C74.6039 72.0043 74.1861 72.644 74.2286 73.4033C74.2697 74.1626 74.7582 74.7523 75.3757 74.7466C75.996 74.7409 76.4789 74.0956 76.4336 73.2807C76.3868 72.463 75.8359 71.8761 75.2185 71.9374Z",
    fill: "#67472D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6832 80.2527C75.2907 80.3609 75.8827 79.8125 75.9889 79.0033C76.0909 78.1941 75.6547 77.5175 75.0372 77.4676C74.4226 77.4206 73.893 77.9676 73.7981 78.7198C73.7018 79.472 74.0728 80.1415 74.6832 80.2527Z",
    fill: "#67472D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3815 82.106C73.7768 81.9607 73.1721 82.4294 72.9569 83.1688C72.7416 83.9067 72.9979 84.6375 73.5828 84.8384C74.1691 85.0421 74.8432 84.5848 75.0755 83.7927C75.3049 82.9993 74.9792 82.2542 74.3815 82.106Z",
    fill: "#67472D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 20,
    width: 30,
    height: 33
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6812 21.2728C62.3985 19.5764 70.1889 25.1781 72.0799 33.7808C73.9764 42.3855 69.2569 50.7322 61.5422 52.4303C53.8277 54.127 46.0398 48.5285 44.1431 39.9252C42.2493 31.3222 46.9695 22.9699 54.6812 21.2728Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.312 18.2407L38.6764 51.5326L73.9142 55.4628L77.5499 22.1709L42.312 18.2407Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8245 52.3181C44.064 48.788 40.753 36.4141 45.4249 24.6869C50.0997 12.9584 60.993 6.31411 69.7506 9.84564C78.5111 13.3786 81.8235 25.7525 77.1487 37.4797C72.4754 49.2068 61.5835 55.8539 52.8245 52.3181Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8613 52.2269C44.1419 48.7068 40.8436 36.3927 45.4958 24.714C50.1507 13.0367 60.993 6.42236 69.7124 9.93965C78.4346 13.4569 81.7315 25.7739 77.0779 37.4497C72.4258 49.127 61.5835 55.7428 52.8613 52.2269Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8995 52.1286C44.2183 48.6284 40.9356 36.367 45.5665 24.741C50.1989 13.1193 60.9944 6.53348 69.6756 10.0365C78.3567 13.5367 81.6394 25.7981 77.0057 37.4212C72.3762 49.0458 61.5835 55.6316 52.8995 52.1286Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9377 52.0374C44.2948 48.5515 41.0291 36.3414 45.6402 24.7695C50.2498 13.2005 60.9944 6.64459 69.6387 10.132C78.2802 13.6151 81.5488 25.8251 76.9363 37.3942C72.3238 48.966 61.5807 55.5205 52.9377 52.0374Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9746 51.9391C44.3727 48.4689 41.1169 36.3186 45.7082 24.7995C50.3022 13.2817 60.9958 6.75714 69.5991 10.226C78.2024 13.6963 81.4553 25.8465 76.8669 37.3657C72.2757 48.8848 61.5793 55.4094 52.9746 51.9391Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0142 51.8451C44.4506 48.3919 41.2118 36.2944 45.7804 24.8308C50.349 13.3615 60.9958 6.86542 69.5623 10.3214C78.1273 13.7775 81.3647 25.8693 76.7961 37.3358C72.2247 48.8036 61.5764 55.2983 53.0142 51.8451Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0511 51.7511C44.5257 48.3122 41.3024 36.273 45.8526 24.8593C50.4 13.4427 60.9972 6.97652 69.5255 10.4155C78.048 13.8544 81.2726 25.8935 76.7239 37.3073C72.1751 48.721 61.5764 55.1872 53.0511 51.7511Z",
    fill: "#F9FBFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0879 51.6557C44.6007 48.2338 41.3931 36.2474 45.9234 24.8835C50.4495 13.5239 61.0001 7.08765 69.4858 10.5095C77.9715 13.9313 81.182 25.9149 76.6545 37.2788C72.1256 48.6427 61.575 55.0789 53.0879 51.6557Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1275 51.5616C44.68 48.1526 41.4851 36.2246 45.9942 24.9149C50.4991 13.6037 61.0015 7.19877 69.4476 10.6049C77.8951 14.0111 81.09 25.942 76.5837 37.2517C72.076 48.5586 61.5736 54.9664 53.1275 51.5616Z",
    fill: "#F7FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1643 51.4662C44.7565 48.0743 41.5758 36.1989 46.0636 24.9448C50.5501 13.6877 61.0015 7.30988 69.4107 10.699C77.82 14.0909 80.9979 25.9662 76.51 37.2204C72.0264 48.4788 61.5736 54.8553 53.1643 51.4662Z",
    fill: "#F6FAFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2026 51.3693C44.8344 47.9945 41.6706 36.1776 46.1358 24.9704C50.5996 13.7661 61.0071 7.41957 69.3725 10.7973C77.7421 14.1692 80.9073 25.989 76.4406 37.1933C71.974 48.3976 61.5722 54.7441 53.2026 51.3693Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2408 51.2781C44.9094 47.9175 41.7599 36.1534 46.2052 24.9989C50.6506 13.8487 61.0057 7.53353 69.3343 10.8884C77.6642 14.249 80.8124 26.0103 76.3698 37.1648C71.9259 48.3164 61.5708 54.6359 53.2408 51.2781Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2791 51.1827C44.9873 47.8378 41.8533 36.1306 46.2761 25.0288C50.7002 13.9299 61.0071 7.64181 69.2989 10.9825C77.5878 14.3274 80.7232 26.0346 76.2976 37.1363C71.8749 48.2367 61.568 54.5248 53.2791 51.1827Z",
    fill: "#F3F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3159 51.0858C45.0666 47.7608 41.9454 36.1049 46.3469 25.0587C50.7498 14.0097 61.0085 7.75006 69.2578 11.0807C77.5113 14.4057 80.6297 26.0616 76.2268 37.1078C71.8253 48.1554 61.5679 54.4136 53.3159 51.0858Z",
    fill: "#F2F7FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3541 50.9932C45.1403 47.6796 42.036 36.0821 46.4177 25.0858C50.7993 14.088 61.0086 7.86404 69.221 11.1748C77.4334 14.4855 80.5391 26.0858 76.1574 37.0793C71.7758 48.0757 61.5637 54.3054 53.3541 50.9932Z",
    fill: "#F1F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3924 50.8964C45.2153 47.5999 42.1267 36.0579 46.4885 25.1114C50.8489 14.1749 61.01 7.97232 69.1856 11.2702C77.3569 14.5667 80.4484 26.1087 76.0866 37.0523C71.7248 47.9945 61.5637 54.1928 53.3924 50.8964Z",
    fill: "#F0F6F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4292 50.8023C45.2961 47.5215 42.2201 36.0337 46.5593 25.1428C50.9013 14.2519 61.01 8.08342 69.1459 11.3642C77.279 14.645 80.3535 26.13 76.0158 37.0238C71.6766 47.9133 61.5623 54.0817 53.4292 50.8023Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4674 50.7069C45.3725 47.4432 42.3122 36.0109 46.6301 25.1727C50.9509 14.3331 61.0142 8.19454 69.1077 11.4583C77.2054 14.722 80.2643 26.1542 75.945 36.9924C71.6242 47.8306 61.5623 53.9706 53.4674 50.7069Z",
    fill: "#EEF5F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5056 50.6128C45.449 47.3634 42.4014 35.9853 46.6995 25.2012C51.0004 14.4143 61.0142 8.30423 69.0723 11.5565C77.1275 14.8003 80.1723 26.1813 75.8756 36.9654C71.5747 47.7523 61.5609 53.8623 53.5056 50.6128Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5425 50.5174C45.5241 47.2836 42.4949 35.9625 46.7746 25.2283C51.0486 14.4969 61.0171 8.41535 69.0326 11.6477C77.0482 14.8815 80.0816 26.2055 75.8034 36.9369C71.5265 47.6682 61.5595 53.7512 53.5425 50.5174Z",
    fill: "#ECF4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5807 50.4234C45.602 47.2038 42.5855 35.9382 46.844 25.2567C51.0996 14.5752 61.0185 8.52646 68.9944 11.7432C76.9731 14.9599 79.9896 26.2283 75.734 36.9098C71.4741 47.5913 61.5595 53.6401 53.5807 50.4234Z",
    fill: "#EBF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.619 50.3265C45.6799 47.1269 42.6776 35.914 46.9148 25.2881C51.1506 14.6579 61.0185 8.63473 68.959 11.84C76.8967 15.0396 79.899 26.2497 75.6632 36.8785C71.4274 47.5073 61.5566 53.5318 53.619 50.3265Z",
    fill: "#E9F3F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6558 50.2339C45.7563 47.0485 42.771 35.8912 46.9856 25.3151C51.1987 14.7391 61.0199 8.74584 68.9193 11.9312C76.8188 15.1166 79.8055 26.2739 75.5895 36.85C71.375 47.4261 61.5552 53.4193 53.6558 50.2339Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.694 50.137C45.8342 46.9673 42.8617 35.8656 47.0564 25.3436C51.2511 14.8203 61.0213 8.85696 68.8811 12.0267C76.7409 15.1992 79.712 26.3009 75.5201 36.8229C71.324 47.3463 61.5538 53.3081 53.694 50.137Z",
    fill: "#E7F2F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7336 50.0416C45.9121 46.8862 42.9551 35.8428 47.1272 25.3707C51.2992 14.9 61.0227 8.96525 68.8457 12.1235C76.6644 15.2761 79.6228 26.3252 75.4493 36.7944C71.2758 47.2651 61.5509 53.197 53.7336 50.0416Z",
    fill: "#E6F1F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7691 49.9476C45.9886 46.8092 43.0444 35.8186 47.1966 25.4021C51.3488 14.9813 61.0227 9.07922 68.806 12.219C76.5865 15.3573 79.5293 26.3451 75.3771 36.7645C71.2263 47.1853 61.5495 53.0859 53.7691 49.9476Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8045 49.8536C46.065 46.7323 43.1378 35.7944 47.2674 25.4291C51.4012 15.0625 61.0255 9.18891 68.7678 12.313C76.5129 15.4343 79.4401 26.3694 75.3063 36.7374C71.1767 47.1041 61.5495 52.9748 53.8045 49.8536Z",
    fill: "#E4F0F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8469 49.7581C46.1429 46.6525 43.2299 35.7716 47.3382 25.4533C51.4479 15.1422 61.027 9.29858 68.731 12.4042C76.4322 15.5126 79.3467 26.3935 75.2355 36.7061C71.1243 47.0201 61.5481 52.8637 53.8469 49.7581Z",
    fill: "#E3EFF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8824 49.6641C46.218 46.5728 43.3205 35.7459 47.4104 25.4847C51.5003 15.2263 61.0298 9.41114 68.6927 12.5025C76.3557 15.591 79.2546 26.4178 75.1647 36.6819C71.0776 46.9431 61.5467 52.7554 53.8824 49.6641Z",
    fill: "#E2EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9178 49.5686C46.2945 46.4915 43.4111 35.7231 47.4798 25.5146C51.5485 15.3032 61.0298 9.52083 68.6531 12.5965C76.2792 15.6707 79.1626 26.442 75.0939 36.6505C71.0252 46.8591 61.5467 52.6443 53.9178 49.5686Z",
    fill: "#E1EEF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9602 49.4746C46.3724 46.4146 43.5032 35.6989 47.552 25.5459C51.5995 15.3844 61.0312 9.63338 68.6191 12.692C76.2056 15.752 79.0719 26.4648 75.0259 36.6235C70.9756 46.7779 61.5453 52.5318 53.9602 49.4746Z",
    fill: "#E0EDF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9957 49.3806C46.4488 46.3363 43.5967 35.6776 47.6243 25.5716C51.649 15.4656 61.0326 9.74592 68.5795 12.786C76.1263 15.8303 78.9813 26.489 74.9537 36.5921C70.9261 46.6981 61.5425 52.4207 53.9957 49.3806Z",
    fill: "#DFEDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0311 49.2823C46.5239 46.2579 43.6845 35.6519 47.6937 25.5986C51.6972 15.5482 61.0326 9.85274 68.5398 12.88C76.047 15.9101 78.8864 26.5104 74.8829 36.5665C70.8737 46.6169 61.5411 52.3124 54.0311 49.2823Z",
    fill: "#DEECF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0735 49.1911C46.6046 46.1781 43.7793 35.6291 47.7645 25.63C51.751 15.628 61.0341 9.96528 68.503 12.9783C75.9705 15.9884 78.7958 26.5374 74.8121 36.5366C70.8269 46.5357 61.5382 52.2012 54.0735 49.1911Z",
    fill: "#DDECF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.109 49.0928C46.6811 46.0955 43.87 35.6063 47.8339 25.6599C51.7977 15.7106 61.0341 10.075 68.4647 13.0695C75.8954 16.0696 78.7037 26.5617 74.7398 36.5081C70.776 46.4559 61.5382 52.0902 54.109 49.0928Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1472 48.9988C46.7576 46.0186 43.9634 35.5821 47.9061 25.6855C51.8501 15.7918 61.0383 10.1847 68.4279 13.1649C75.8189 16.148 78.6131 26.5844 74.6704 36.4782C70.7264 46.3747 61.5368 51.9819 54.1472 48.9988Z",
    fill: "#DBEBF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1868 48.9048C46.8326 45.9416 44.0541 35.5579 47.9769 25.714C51.8997 15.873 61.0397 10.2972 68.3911 13.2632C75.7397 16.2263 78.521 26.6072 74.5996 36.4539C70.6754 46.2949 61.5354 51.8707 54.1868 48.9048Z",
    fill: "#DAEAF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2222 48.8093C46.9105 45.8633 44.1447 35.5351 48.0477 25.7439C51.9493 15.9528 61.0397 10.4069 68.3529 13.3572C75.6646 16.3032 78.4275 26.6315 74.526 36.4226C70.6258 46.2137 61.5354 51.7582 54.2222 48.8093Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2605 48.7153C46.9884 45.7821 44.2396 35.5095 48.1171 25.7739C52.0002 16.0354 61.0425 10.5152 68.3146 13.4484C75.5909 16.3845 78.3397 26.6571 74.4566 36.3955C70.5762 46.1326 61.5339 51.6471 54.2605 48.7153Z",
    fill: "#D8E9EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2973 48.6199C47.0649 45.7009 44.3274 35.4867 48.1879 25.7981C52.0484 16.1124 61.044 10.6292 68.2778 13.5439C75.5102 16.4628 78.2449 26.6799 74.3858 36.3628C70.5253 46.0528 61.534 51.5388 54.2973 48.6199Z",
    fill: "#D7E8EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3355 48.5258C47.1399 45.624 44.4209 35.4624 48.2601 25.8266C52.0994 16.195 61.0454 10.7388 68.2396 13.6407C75.4338 16.5426 78.1542 26.7041 74.315 36.3371C70.4785 45.9687 61.5297 51.4277 54.3355 48.5258Z",
    fill: "#D6E8EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3738 48.4318C47.2178 45.5471 44.5129 35.4382 48.3309 25.8579C52.1489 16.2776 61.0454 10.85 68.1999 13.7347C75.3573 16.6195 78.0622 26.7255 74.2441 36.3086C70.4261 45.8904 61.5297 51.3166 54.3738 48.4318Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.412 48.3364C47.2971 45.4673 44.6036 35.4154 48.4018 25.8878C52.1999 16.3574 61.0468 10.9597 68.1631 13.8288C75.2808 16.7007 77.9715 26.7497 74.1734 36.2802C70.3766 45.8078 61.5283 51.2083 54.412 48.3364Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5749 47.9247C47.6285 45.1225 45.0001 35.3129 48.709 26.0075C52.4152 16.7093 61.0524 11.4397 68.0002 14.2405C74.9466 17.0426 77.5736 26.8523 73.8674 36.1548C70.1613 45.4573 61.524 50.7268 54.5749 47.9247Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7391 47.5158C47.9599 44.7806 45.3966 35.2089 49.0149 26.1329C52.6333 17.0597 61.0567 11.917 67.8345 14.6493C74.6124 17.3845 77.1742 26.9591 73.5587 36.0294C69.9446 45.1068 61.5184 50.2482 54.7391 47.5158Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9048 47.1041C48.2955 44.4387 45.7946 35.1034 49.3223 26.2582C52.8471 17.4101 61.0638 12.397 67.6731 15.0624C74.2796 17.7278 76.7791 27.0602 73.2514 35.9083C69.7265 44.755 61.5113 49.7695 54.9048 47.1041Z",
    fill: "#E0EDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0663 46.6924C48.6283 44.0968 46.1925 35.0009 49.6296 26.3807C53.0652 17.7606 61.0695 12.8757 67.5074 15.4741C73.9482 18.0697 76.3826 27.1628 72.9455 35.7858C69.5099 44.4045 61.5056 49.2908 55.0663 46.6924Z",
    fill: "#E3EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2306 46.2807C48.9597 43.7549 46.589 34.9011 49.9369 26.5032C53.2791 18.111 61.0751 13.3558 67.346 15.883C73.6154 18.4116 75.9861 27.2654 72.6382 35.6604C69.2932 44.0541 61.5 48.8093 55.2306 46.2807Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3934 45.8719C49.2911 43.4116 46.9884 34.7957 50.24 26.6286C53.4957 18.4629 61.0808 13.8359 67.1803 16.2947C73.2798 18.7535 75.5881 27.3708 72.3309 35.538C69.078 43.7065 61.4957 48.3307 55.3934 45.8719Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5563 45.4601C49.6281 43.0668 47.3878 34.6946 50.5487 26.754C53.7138 18.8134 61.085 14.3145 67.0174 16.7064C72.9498 19.0969 75.1916 27.4748 72.0264 35.4126C68.8613 43.3532 61.4872 47.852 55.5563 45.4601Z",
    fill: "#EAF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7234 45.0485C49.9624 42.725 47.7829 34.5892 50.856 26.8737C53.9319 19.1638 61.0935 14.7918 66.856 17.1153C72.617 19.4416 74.7951 27.5774 71.7205 35.2901C68.646 43.0028 61.4844 47.3705 55.7234 45.0485Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8848 44.6382C50.2937 42.3816 48.1794 34.4852 51.1619 26.9976C54.1457 19.5128 61.0978 15.2704 66.6888 17.5241C72.2813 19.7807 74.3957 27.6771 71.4118 35.1647C68.4293 42.6523 61.4759 46.8947 55.8848 44.6382Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0477 44.2265C50.6251 42.0397 48.5759 34.3826 51.4692 27.123C54.3639 19.8633 61.1063 15.752 66.5274 17.9387C71.9485 20.1226 73.9992 27.7825 71.1045 35.0422C68.2112 42.3019 61.4716 46.4146 56.0477 44.2265Z",
    fill: "#F0F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2134 43.8176C50.9608 41.7007 48.9739 34.2801 51.7765 27.2455C54.5777 20.2137 61.1091 16.2306 66.3631 18.3475C71.6157 20.4673 73.5998 27.8851 70.7986 34.9197C67.9946 41.9514 61.4646 45.936 56.2134 43.8176Z",
    fill: "#F2F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3748 43.4059C51.2936 41.3574 49.3704 34.176 52.0838 27.3708C54.7958 20.5656 61.1162 16.7093 66.1989 18.7592C71.2844 20.8092 73.2033 27.9891 70.4913 34.7943C67.7793 41.601 61.4603 45.4573 56.3748 43.4059Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5419 42.9971C51.6264 41.0126 49.7669 34.0735 52.3897 27.4933C55.011 20.9161 61.1204 17.1879 66.036 19.1681C70.9487 21.1511 72.8053 28.0917 70.184 34.669C67.5626 41.2505 61.4547 44.9786 56.5419 42.9971Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7034 42.5853C51.9578 40.6707 50.1663 33.9709 52.6956 27.6187C55.2291 21.2665 61.1261 17.6666 65.8703 19.5798C70.6159 21.4944 72.4102 28.1942 69.8795 34.5464C67.3488 40.8986 61.449 44.5 56.7034 42.5853Z",
    fill: "#F6FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8662 42.1736C52.292 40.3288 50.5614 33.8683 53.0043 27.7412C55.4458 21.6141 61.1332 18.1452 65.7089 19.9929C70.2831 21.8377 72.0137 28.2982 69.5722 34.4253C67.1307 40.5482 61.4419 44.0185 56.8662 42.1736Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0319 41.7648C52.6276 39.9869 50.9622 33.7658 53.3102 27.8666C55.6611 21.9645 61.1389 18.6268 65.5446 20.4018C69.9517 22.1797 71.6172 28.4036 69.2663 34.3C66.914 40.1978 61.4363 43.5398 57.0319 41.7648Z",
    fill: "#F9FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1934 41.3531C52.959 39.645 51.3587 33.6632 53.6175 27.9891C55.8777 22.315 61.1445 19.1054 65.3803 20.8135C69.6175 22.5216 71.2206 28.5034 68.959 34.1775C66.6973 39.8473 61.432 43.0612 57.1934 41.3531Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3605 40.9414C53.2904 39.3031 51.7552 33.5563 53.9234 28.1116C56.093 22.6668 61.1473 19.584 65.2174 21.2252C69.2819 22.8634 70.8227 28.6073 68.6517 34.0549C66.4821 39.4997 61.4249 42.5825 57.3605 40.9414Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5219 40.5297C53.6246 38.9584 52.1518 33.4566 54.2307 28.237C56.3111 23.0173 61.1573 20.0627 65.0532 21.6369C68.9491 23.2053 70.4219 28.7099 68.343 33.9267C66.264 39.1464 61.4207 42.101 57.5219 40.5297Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6862 40.1208C53.9588 38.6179 52.5483 33.3512 54.538 28.3623C56.5278 23.3706 61.1615 20.5414 64.8889 22.0429C68.6177 23.5487 70.0268 28.8153 68.037 33.8042C66.0502 38.796 61.4122 41.6223 57.6862 40.1208Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8505 39.7105C54.2916 38.2746 52.9448 33.2501 54.8454 28.4834C56.7459 23.7196 61.1686 21.0215 64.7246 22.4574C68.2835 23.8906 69.6274 28.9179 67.7297 33.6817C65.8321 38.4455 61.4079 41.1437 57.8505 39.7105Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0119 39.2988C54.623 37.9327 53.3414 33.1446 55.1527 28.6059C56.9597 24.0701 61.1728 21.5001 64.5617 22.8663C67.9507 24.2325 69.2309 29.0205 67.4252 33.5564C65.6154 38.0951 61.4008 40.665 58.0119 39.2988Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1776 38.8871C54.9587 37.5908 53.7379 33.0406 55.4586 28.7313C57.175 24.4219 61.1771 21.9816 64.3975 23.278C67.615 24.5772 68.833 29.1216 67.118 33.4338C65.3987 37.7446 61.398 40.1863 58.1776 38.8871Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3391 38.4783C55.2914 37.2489 54.1373 32.9381 55.7659 28.8567C57.3931 24.7724 61.1842 22.4575 64.236 23.6869C67.2865 24.9191 68.4378 29.2271 66.8121 33.3113C65.182 37.3928 61.3909 39.7063 58.3391 38.4783Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5048 38.0666C55.6242 36.9041 54.5352 32.8355 56.0732 28.9792C57.6083 25.1228 61.1898 22.9361 64.0717 24.0986C66.9537 25.261 68.0427 29.3296 66.5062 33.186C64.9668 37.0423 61.3853 39.2276 58.5048 38.0666Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.669 37.6549C55.9556 36.5608 54.9332 32.7329 56.3805 29.1045C57.8278 25.4733 61.1955 23.4176 63.9075 24.5103C66.6181 25.6029 67.6462 29.4322 66.1989 33.0606C64.7515 36.6918 61.3796 38.7489 58.669 37.6549Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8305 37.2432C56.2899 36.2189 55.3297 32.6304 56.6864 29.2271C58.0431 25.8237 61.2012 23.8963 63.7418 24.9206C66.2852 25.9477 67.2482 29.5362 65.8915 32.9395C64.5348 36.3414 61.3739 38.2703 58.8305 37.2432Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9962 36.8343C56.6227 35.877 55.7262 32.5278 56.9937 29.3496C58.2583 26.1742 61.2082 24.3778 63.5789 25.3323C65.9524 26.2896 66.8503 29.6402 65.5828 32.817C64.3167 35.991 61.3697 37.7916 58.9962 36.8343Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.159 36.4226C56.9569 35.5351 56.1242 32.4238 57.301 29.4749C58.4736 26.526 61.2125 24.8536 63.4175 25.7411C65.6196 26.6315 66.4524 29.7428 65.2783 32.6916C64.1001 35.6405 61.3612 37.313 59.159 36.4226Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3233 36.0109C57.2883 35.1932 56.5221 32.3184 57.6055 29.5974C58.6903 26.8765 61.2196 25.3351 63.2518 26.1557C65.2854 26.9734 66.0544 29.8453 64.9696 32.5691C63.8834 35.2901 61.3569 36.8315 59.3233 36.0109Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4876 35.602C57.6239 34.8513 56.9186 32.2187 57.9128 29.7228C58.907 27.2269 61.2238 25.8109 63.0889 26.5645C64.9512 27.3153 65.655 29.9479 64.6623 32.4437C63.6682 34.9396 61.3485 36.3528 59.4876 35.602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.649 35.1932C57.9567 34.508 57.3152 32.1132 58.2187 29.8453C59.1236 27.5774 61.2309 26.2924 62.9232 26.9762C64.6184 27.6571 65.2571 30.0504 64.355 32.3184C63.4529 34.5892 61.347 35.8741 59.649 35.1932Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8147 34.7801C58.2881 34.1646 57.7103 32.0121 58.526 29.9693C59.3403 27.9264 61.2351 26.7696 62.7618 27.3836C64.2856 27.9991 64.8605 30.1516 64.0477 32.1944C63.2362 34.2387 61.3385 35.3926 59.8147 34.7801Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9776 34.3684C58.6209 33.8228 58.1111 31.9067 58.8333 30.0918C59.557 28.2783 61.2408 27.2512 62.5975 27.7968C63.9514 28.3424 64.464 30.2585 63.7418 32.0734C63.0181 33.8883 61.3343 34.9168 59.9776 34.3684Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1419 33.9566C58.9551 33.4808 58.5076 31.8055 59.1406 30.2143C59.7737 28.6287 61.2465 27.7298 62.4332 28.2056C63.62 28.6871 64.0675 30.3624 63.4359 31.948C62.8014 33.5364 61.3286 34.4353 60.1419 33.9566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3061 33.5478C59.2893 33.1389 58.9055 31.7001 59.4465 30.3396C59.9889 28.9792 61.2535 28.2056 62.2718 28.6173C63.2886 29.029 63.671 30.4622 63.1286 31.8255C62.5848 33.186 61.3215 33.9567 60.3061 33.5478Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4676 33.1361C59.6207 32.7942 59.3021 31.5975 59.7538 30.4622C60.2042 29.3296 61.2578 28.6871 62.1047 29.029C62.953 29.3709 63.2745 30.5647 62.8199 31.7001C62.3695 32.8355 61.3159 33.478 60.4676 33.1361Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6347 32.7244C59.9549 32.4523 59.7 31.495 60.0597 30.5875C60.4237 29.6801 61.2663 29.1658 61.9447 29.4379C62.6202 29.7128 62.8779 30.6701 62.514 31.5776C62.1528 32.4851 61.3102 32.9993 60.6347 32.7244Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7961 32.3155C60.2891 32.109 60.0965 31.3924 60.3656 30.71C60.6389 30.0291 61.2706 29.6473 61.779 29.851C62.286 30.0561 62.4786 30.7741 62.2081 31.4537C61.9376 32.1346 61.3045 32.5192 60.7961 32.3155Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9604 31.9038C60.6234 31.7671 60.4931 31.2884 60.6729 30.8354C60.8542 30.3795 61.2748 30.1231 61.6147 30.2599C61.9546 30.3995 62.082 30.8781 61.9008 31.3312C61.7209 31.7842 61.2975 32.0406 60.9604 31.9038Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 32,
    height: 30
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1395 31.7315C75.6717 39.2547 70.994 47.644 62.6952 50.4675C54.395 53.2968 45.6175 49.4903 43.084 41.9699C40.5519 34.4496 45.2267 26.0631 53.5255 23.2338C61.8243 20.4075 70.6074 24.214 73.1395 31.7315Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1247 31.495C60.9547 31.4252 60.8896 31.1858 60.9802 30.9608C61.0709 30.73 61.2833 30.6046 61.4532 30.6744C61.6203 30.7414 61.6841 30.9807 61.5949 31.2086C61.5042 31.4337 61.2946 31.5619 61.1247 31.495Z",
    fill: "white"
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9815 31.995C61.9815 31.995 66.3221 31.767 69.4872 27.6343C69.4872 27.6343 68.9038 34.9125 65.0234 36.5123C62.9332 37.3742 59.1081 36.5864 61.9815 31.995Z",
    fill: "#F37D22"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8958 30.7941C58.1904 31.6673 57.8548 32.5691 57.1481 32.8113C56.4414 33.0506 55.6314 32.5392 55.3368 31.6673C55.0437 30.7941 55.3793 29.8952 56.086 29.653C56.7926 29.4108 57.6027 29.9222 57.8958 30.7941Z",
    fill: "#67472D"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3577 28.4848C65.6282 29.2883 65.3662 30.1017 64.7728 30.304C64.1794 30.5049 63.4784 30.0177 63.2093 29.2156C62.9417 28.415 63.2023 27.5987 63.797 27.3964C64.3848 27.1956 65.0858 27.6828 65.3577 28.4848Z",
    fill: "#67472D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0822 34.2458C61.0822 34.2458 64.9357 35.8485 67.4055 33.1332C67.4055 33.1332 69.4405 30.9821 69.4872 27.6358C69.4872 27.6358 68.5752 35.7915 64.6921 36.5593C64.6921 36.5593 60.5441 37.9725 61.0822 34.2458Z",
    fill: "#C16128"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2729 30.4294L56.6737 30.0903C56.8181 30.2684 56.9484 30.4579 57.0603 30.6573L56.6043 30.9166C56.5108 30.7442 56.4003 30.579 56.2729 30.4294Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8891 27.9577C63.882 27.9406 63.8749 27.925 63.8721 27.9136H63.8764L64.3763 27.764C64.3805 27.7782 64.3805 27.7868 64.3848 27.791C64.4272 27.9193 64.4924 28.0332 64.5802 28.1443L64.1737 28.4734C64.0477 28.3196 63.9514 28.1472 63.8891 27.9577Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2615 40.4371C56.3069 40.5866 56.2205 40.749 56.0675 40.7932C55.916 40.8374 55.756 40.749 55.7106 40.5952C55.6653 40.4428 55.7531 40.2832 55.9089 40.239C56.0576 40.192 56.2148 40.2818 56.2615 40.4371Z",
    fill: "#69483B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1396 41.2305C57.1849 41.383 57.0971 41.5454 56.9441 41.5867C56.7926 41.6308 56.6354 41.5454 56.5887 41.3915C56.5434 41.2377 56.6326 41.0767 56.7827 41.0325C56.9342 40.9884 57.0957 41.0767 57.1396 41.2305Z",
    fill: "#69483B"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5741 42.0625C58.6209 42.2149 58.5317 42.3745 58.3787 42.4187C58.2272 42.4657 58.07 42.3773 58.0233 42.2206C57.9808 42.0682 58.0672 41.9087 58.2201 41.8645C58.3716 41.8203 58.5317 41.9087 58.5741 42.0625Z",
    fill: "#69483B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M59.979 42.6024C60.0243 42.7549 59.9379 42.9173 59.7822 42.9586C59.6335 43.0056 59.4734 42.9173 59.4267 42.7634C59.3856 42.611 59.4692 42.4486 59.6235 42.4044C59.7765 42.3631 59.9351 42.4486 59.979 42.6024Z",
    fill: "#69483B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M61.694 42.8503C61.7379 43.0027 61.6515 43.1623 61.4986 43.2093C61.347 43.2506 61.187 43.1651 61.1431 43.0113C61.1006 42.8588 61.1856 42.6964 61.34 42.6523C61.4901 42.6081 61.6501 42.6964 61.694 42.8503Z",
    fill: "#69483B"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3509 42.7164C63.3948 42.866 63.3084 43.0284 63.1555 43.0725C63.0025 43.1167 62.8411 43.0312 62.7986 42.8745C62.7519 42.7221 62.8411 42.5625 62.9926 42.5184C63.1456 42.4742 63.3042 42.5597 63.3509 42.7164Z",
    fill: "#69483B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3024 42.2406C65.3463 42.393 65.2599 42.5554 65.107 42.5996C64.9555 42.6437 64.7954 42.5583 64.7515 42.4044C64.709 42.2491 64.7954 42.0896 64.9484 42.0454C65.1013 42.0013 65.2599 42.0867 65.3024 42.2406Z",
    fill: "#69483B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9834 41.4969C67.0273 41.6522 66.9381 41.8118 66.7837 41.8559C66.6322 41.9001 66.4736 41.8118 66.4283 41.6579C66.3844 41.5055 66.4708 41.3459 66.6237 41.2989C66.7767 41.2548 66.9381 41.3445 66.9834 41.4969Z",
    fill: "#69483B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3359 40.4983C68.3798 40.6508 68.2934 40.8132 68.1376 40.8573C67.9889 40.9015 67.8289 40.816 67.785 40.6621C67.7411 40.5069 67.8275 40.3473 67.9776 40.3032C68.1333 40.259 68.292 40.3459 68.3359 40.4983Z",
    fill: "#69483B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6317 39.4698C69.6728 39.6222 69.5864 39.7817 69.4334 39.8259C69.2791 39.8701 69.1219 39.7846 69.078 39.6307C69.0355 39.4783 69.1204 39.3159 69.2734 39.2717C69.4263 39.2276 69.585 39.3159 69.6317 39.4698Z",
    fill: "#69483B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1511 49.0871C48.1511 49.0871 47.0181 51.9861 48.6014 55.6345C48.6014 55.6345 66.3532 56.5946 71.2447 48.9902C71.2447 48.9902 72.0519 43.6124 69.1119 44.8191C66.1804 46.0214 53.7903 52.2297 48.1511 49.0871Z",
    fill: "url(#paint0_linear_2436_51438)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2091 47.9802C64.2091 47.9802 72.6566 56.9423 69.7025 69.0811C69.7025 69.0811 73.8094 71.1211 77.4716 68.2548C77.4716 68.2548 75.2171 50.8094 66.7059 47.0286L64.2091 47.9802Z",
    fill: "#DF1A22"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4538 46.3334C66.4538 46.3334 66.9041 53.529 75.1746 56.3397C83.4422 59.1475 87.0053 64.531 84.772 69.3717C84.772 69.3717 92.2424 66.2804 93.7237 64.5025C93.7237 64.5025 90.0445 57.599 83.9039 55.7214C74.9253 52.972 69.711 52.5574 70.3539 44.7422C70.3553 44.7422 67.108 44.1965 66.4538 46.3334Z",
    fill: "#ED1C24"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9449 31.1588C53.0341 31.1246 52.9803 31.0477 53.0468 31.0063C53.0511 30.9978 53.0057 30.9949 53.0199 30.9835C53.0935 30.9479 53.0851 30.861 53.0624 30.7827L53.0496 30.7855C53.0468 30.7713 53.0851 30.7656 53.0865 30.7528L53.0652 30.7499C53.0865 30.7528 53.0836 30.73 53.102 30.7271L53.0695 30.7072L53.0964 30.7043C53.1644 30.7015 53.1105 30.6573 53.1502 30.6345H53.1318C53.1828 30.6003 53.1955 30.5448 53.2267 30.5006L53.1898 30.4892C53.2153 30.4949 53.2281 30.4835 53.238 30.4693C53.2139 30.455 53.2706 30.4579 53.2592 30.4379H53.2536C53.2847 30.4351 53.2451 30.4123 53.2805 30.418L53.2621 30.4009C53.3017 30.4094 53.2479 30.3781 53.2706 30.3752H53.2777L53.2819 30.3553L53.2777 30.3525C53.2932 30.3354 53.2777 30.3168 53.3074 30.3297C53.2847 30.3126 53.2876 30.3411 53.2607 30.3183C53.3131 30.2713 53.3173 30.1958 53.3626 30.143L53.3428 30.1202L53.3782 30.1032L53.3669 30.0889C53.364 30.069 53.4051 30.0889 53.398 30.0747L53.3683 30.0633L53.415 30.0405L53.3966 30.0376C53.4278 30.0376 53.4051 30.012 53.4292 30.0106L53.4065 30.0049C53.3994 29.9778 53.4448 30.0191 53.4419 29.9963L53.4235 29.9878C53.4618 29.9878 53.466 29.9621 53.4858 29.9522H53.4773L53.517 29.9051C53.5127 29.8937 53.4759 29.8852 53.4929 29.8738C53.5241 29.8909 53.5227 29.851 53.5524 29.8823C53.5552 29.8652 53.5581 29.8382 53.5765 29.8353C53.5581 29.8353 53.5425 29.8083 53.5311 29.8125L53.517 29.7954C53.5028 29.7869 53.5156 29.8068 53.5014 29.7926L53.5283 29.7698C53.5538 29.7727 53.5963 29.7812 53.6105 29.7641L53.5722 29.7413L53.6473 29.7556C53.6529 29.7499 53.6246 29.7385 53.6388 29.7356L53.66 29.7413C53.66 29.7356 53.6841 29.7214 53.6558 29.7L53.6345 29.6943L53.6629 29.6772L53.6586 29.6744C53.6558 29.663 53.6827 29.663 53.6968 29.6829C53.6912 29.6858 53.6784 29.6658 53.6827 29.6801C53.7025 29.6886 53.7153 29.6772 53.7237 29.6687L53.6968 29.6573L53.7676 29.6373C53.7818 29.6487 53.7365 29.6259 53.7436 29.6345C53.7365 29.6017 53.7974 29.6088 53.7804 29.5732L53.796 29.5875L53.7903 29.5618C53.7776 29.5504 53.8002 29.5561 53.8087 29.5504H53.796C53.813 29.5476 53.8555 29.5219 53.8498 29.492H53.8894L53.871 29.4835L53.8654 29.4521C53.8951 29.4578 53.8243 29.4806 53.8498 29.4806C53.8328 29.4635 53.888 29.4806 53.8639 29.4635C53.8696 29.455 53.8965 29.4578 53.8852 29.4407C53.888 29.4436 53.8569 29.4265 53.8597 29.4208L53.8866 29.4179L53.8994 29.4151C53.9178 29.4265 53.905 29.4008 53.922 29.4208C53.9064 29.4065 53.9447 29.4065 53.9135 29.3852L53.888 29.3709L53.9305 29.3823L53.922 29.3738C53.9574 29.3994 53.9277 29.3567 53.9602 29.3681C53.9546 29.3453 53.9815 29.3382 53.9645 29.3182C53.9843 29.3154 54.0027 29.3182 54.0027 29.304L53.9872 29.2983C53.9815 29.284 53.9942 29.2897 54.0042 29.2897L53.9914 29.2456L54.0353 29.2726C54.0084 29.237 54.0792 29.2641 54.0594 29.2313L54.0296 29.2171C54.0056 29.1815 54.0707 29.2228 54.0665 29.1971L54.0905 29.2228C54.0792 29.2028 54.1245 29.2171 54.0976 29.1943C54.1104 29.2 54.099 29.1743 54.1274 29.2C54.1231 29.1587 54.1883 29.1615 54.1514 29.1088C54.1599 29.1116 54.1613 29.0974 54.1755 29.1145C54.184 29.1287 54.1571 29.1116 54.167 29.1202L54.1798 29.1259C54.1812 29.1145 54.184 29.1088 54.1571 29.0946C54.1543 29.0675 54.2152 29.123 54.2222 29.0946L54.2152 29.0775L54.2435 29.0832C54.2492 29.0689 54.2251 29.0561 54.2081 29.039L54.2378 29.0361L54.2237 29.0091C54.235 29.029 54.2407 29.0176 54.2449 29.0176H54.2407L54.2506 29.0005L54.2562 29.0319L54.286 29.0347C54.2647 29.0205 54.2817 29.0119 54.2846 29.0062C54.286 28.9977 54.3058 29.0148 54.3086 29.0119L54.2987 28.992L54.2916 29.0034C54.2888 28.992 54.269 28.9777 54.2916 28.9806C54.3044 28.9834 54.3214 29.0134 54.3242 28.9948L54.2987 28.9834L54.3015 28.9635L54.3171 28.9749L54.3086 28.972C54.3299 28.9806 54.3327 28.9606 54.3511 28.9749L54.3539 28.9478H54.3497C54.3469 28.9307 54.361 28.9279 54.3766 28.9364L54.3724 28.9336L54.3978 28.9279C54.3908 28.9079 54.3398 28.8695 54.3695 28.878C54.3794 28.8695 54.4106 28.8923 54.4191 28.9051C54.4219 28.8794 54.463 28.888 54.4545 28.8524L54.4715 28.8581C54.4871 28.8324 54.5352 28.831 54.5225 28.7854L54.4984 28.7598C54.5168 28.7683 54.4899 28.737 54.5154 28.7598L54.5338 28.794C54.5579 28.7883 54.5763 28.7683 54.5692 28.747L54.5848 28.764C54.5635 28.7413 54.572 28.7256 54.5848 28.7284L54.5989 28.7427L54.5904 28.7227C54.5989 28.7256 54.6216 28.7498 54.6159 28.7284L54.6046 28.7113C54.6216 28.7142 54.6513 28.7227 54.6485 28.7056L54.6329 28.6786L54.657 28.6928L54.6542 28.6373C54.7179 28.6572 54.7491 28.6202 54.7816 28.5988L54.7731 28.5902C54.7717 28.5703 54.793 28.6045 54.7944 28.5902L54.7632 28.5575C54.7646 28.5375 54.7944 28.566 54.8043 28.566C54.8213 28.5803 54.7915 28.5603 54.8071 28.5803C54.8142 28.5831 54.8142 28.5546 54.8354 28.5746L54.8071 28.5418L54.8241 28.5475C54.8128 28.5162 54.7646 28.519 54.7491 28.4806H54.759C54.7462 28.4535 54.7193 28.4663 54.7292 28.4478C54.7462 28.4535 54.7788 28.4791 54.7802 28.492C54.8 28.4891 54.8284 28.5418 54.8454 28.5261C54.8411 28.5119 54.8298 28.5318 54.817 28.5147C54.8114 28.492 54.8425 28.5119 54.8439 28.4977L54.8779 28.5333C54.8779 28.5133 54.8539 28.5133 54.8638 28.5033C54.8779 28.5147 54.8963 28.5176 54.8949 28.5333C54.9204 28.5589 54.8992 28.5162 54.9247 28.5333C54.9119 28.5105 54.8737 28.4948 54.8793 28.4749C54.8935 28.4948 54.9176 28.4891 54.9332 28.5247L54.9077 28.4905C54.9063 28.4706 54.9558 28.5133 54.9275 28.4706L54.9473 28.4877L54.9374 28.4592C54.9445 28.4563 54.9799 28.4734 54.9572 28.4421C54.9615 28.4449 54.9771 28.4307 54.987 28.4592C54.987 28.4791 54.9643 28.4478 54.9799 28.482C54.97 28.4535 54.9983 28.4734 55.0082 28.4791L54.9997 28.4649L55.0252 28.4734L55.0139 28.4535L55.0295 28.4706C55.0521 28.4706 55.0068 28.4378 55.0252 28.435L55.004 28.4264L55.0096 28.4093L55.0578 28.4506C55.0705 28.4506 55.0465 28.4307 55.0663 28.4421L55.0422 28.4278L55.038 28.3922C55.0465 28.3922 55.0734 28.4093 55.0719 28.425L55.062 28.3965L55.0932 28.4193L55.0833 28.3609L55.0521 28.3381L55.0592 28.3353C55.0337 28.3182 55.0507 28.3125 55.028 28.2939L55.0535 28.2968C55.0663 28.3409 55.1059 28.3353 55.1272 28.3751C55.1527 28.3723 55.0776 28.2811 55.1357 28.3224C55.1385 28.3338 55.1668 28.3552 55.1484 28.3523C55.1583 28.3409 55.181 28.3808 55.1838 28.358C55.164 28.3523 55.1682 28.3167 55.1399 28.3053L55.1343 28.3196C55.1272 28.2996 55.1074 28.2868 55.1187 28.2754C55.1286 28.2754 55.1399 28.2669 55.1498 28.2868C55.1654 28.3096 55.1357 28.2925 55.1569 28.3096C55.1767 28.3068 55.1555 28.274 55.1867 28.3096C55.1782 28.3125 55.1895 28.3324 55.2008 28.3452H55.2164L55.2037 28.3367C55.2122 28.3139 55.2263 28.3566 55.2405 28.3395L55.2277 28.3096C55.2051 28.2897 55.2122 28.3367 55.1881 28.2982C55.198 28.2868 55.2136 28.3039 55.2164 28.2897L55.2037 28.2868C55.2065 28.2811 55.1767 28.2313 55.2093 28.2512L55.2348 28.274H55.2787C55.2575 28.2455 55.2971 28.2569 55.2631 28.2384C55.2702 28.2583 55.2461 28.2711 55.2235 28.2526C55.2051 28.217 55.2122 28.264 55.1867 28.2355C55.1994 28.2241 55.1739 28.1942 55.1626 28.1714L55.1796 28.1771L55.2037 28.2184C55.2164 28.2042 55.2376 28.2013 55.2589 28.2156L55.2348 28.1871L55.2872 28.1458C55.2957 28.1842 55.3099 28.1401 55.3198 28.17L55.3382 28.2256L55.3283 28.1999C55.3467 28.2142 55.3184 28.1643 55.3439 28.1885C55.3198 28.1885 55.3169 28.1529 55.2985 28.1273C55.3198 28.133 55.2815 28.1102 55.2957 28.1016L55.3566 28.1045C55.3552 28.0717 55.3963 28.076 55.4118 28.066L55.392 28.0104C55.4019 28.0047 55.4062 28.0489 55.4104 28.0275L55.4048 28.0218C55.4132 28.0218 55.4203 27.9834 55.4501 28.0218L55.4246 27.9934H55.4387L55.4203 27.9706C55.4161 27.9406 55.443 27.9592 55.4501 27.9506L55.4571 27.9763C55.4826 27.9791 55.4841 27.9535 55.5025 27.9478L55.4911 27.9307L55.5067 27.9364C55.4926 27.9164 55.494 27.9008 55.511 27.9107L55.4586 27.8822L55.4841 27.9207C55.4897 27.9378 55.4713 27.9435 55.46 27.9292H55.477C55.4628 27.9036 55.4543 27.9093 55.4402 27.8965L55.4501 27.8936L55.4189 27.8908L55.4288 27.915C55.4132 27.8922 55.4019 27.8922 55.3963 27.9093C55.4019 27.9392 55.3623 27.9093 55.3509 27.9264L55.4033 27.9592L55.392 27.982L55.3396 27.9435L55.3509 27.9606C55.3339 27.9577 55.3212 27.9349 55.3099 27.9492L55.2518 28.0047L55.2617 28.0218C55.2263 27.9934 55.2192 28.0304 55.1952 28.0275C55.1852 28.056 55.1357 28.0446 55.1442 28.0802C55.0946 28.0945 55.0521 28.1059 55.0153 28.1415L55.0408 28.1586C55.0196 28.1472 55.045 28.1757 55.0337 28.1785C55.0295 28.1543 55.0068 28.1643 54.9941 28.1515C54.9856 28.1814 54.9502 28.1785 54.9218 28.1743L54.9346 28.1914C54.8949 28.1743 54.8921 28.2142 54.8779 28.2327L54.8793 28.2583C54.8496 28.2441 54.8454 28.2469 54.8156 28.2441L54.7845 28.2911C54.7108 28.2854 54.6839 28.3381 54.623 28.3523L54.6343 28.3723C54.5522 28.3637 54.5352 28.4449 54.4857 28.4592L54.5126 28.4848C54.5126 28.5076 54.4857 28.5048 54.4658 28.4791C54.4644 28.4991 54.4304 28.4934 54.4432 28.5204C54.4375 28.5375 54.4177 28.5233 54.4049 28.5261C54.395 28.5603 54.3823 28.5646 54.3596 28.5817L54.361 28.5732L54.3809 28.5959C54.3624 28.5959 54.3582 28.6316 54.3341 28.5902C54.3341 28.6316 54.269 28.623 54.2732 28.6715L54.2491 28.6601C54.2293 28.68 54.2279 28.7185 54.1982 28.7185L54.2137 28.7384L54.1883 28.7299C54.1415 28.7413 54.1458 28.8082 54.1118 28.8296C54.0452 28.8652 54.0013 28.9236 53.9518 28.9692L53.9602 28.9749C53.9149 28.9692 53.9503 29.039 53.8965 29.0133C53.9008 29.0247 53.8866 29.0333 53.9022 29.0418C53.8696 29.039 53.8866 29.0917 53.8413 29.0917L53.8498 29.0889C53.8484 29.1188 53.8101 29.1173 53.8045 29.1501L53.8257 29.1558C53.8328 29.1729 53.7761 29.1501 53.8087 29.1786L53.7889 29.1672L53.6657 29.3097C53.6643 29.3652 53.728 29.3567 53.6813 29.3652H53.6728C53.6544 29.3681 53.7025 29.4122 53.677 29.4037C53.6572 29.3837 53.66 29.4037 53.6487 29.3923C53.6501 29.4251 53.6657 29.445 53.6374 29.4507L53.6501 29.4592C53.6034 29.4564 53.6034 29.492 53.5524 29.4849L53.2904 29.8154C53.2338 29.9379 53.1205 30.0291 53.0992 30.1715C53.1275 30.2185 53.1247 30.2214 53.0992 30.2499L53.1134 30.2527C53.0822 30.2413 53.102 30.2755 53.0723 30.267L53.0199 30.4094C53.027 30.4066 53.0525 30.4094 53.0482 30.4151L53.0256 30.4208L53.0341 30.4237L53.0001 30.4208C52.9335 30.5377 52.9548 30.6801 52.9052 30.8026C52.908 30.8354 52.8811 30.8724 52.867 30.9023C52.8769 31.0078 52.8854 31.0947 52.8231 31.183C52.8245 31.1915 52.9123 31.1944 52.9449 31.1588Z",
    fill: "#67472D"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2753 27.2127C66.2753 27.1343 66.1847 27.14 66.1649 27.0788C66.162 27.0702 66.1451 27.1073 66.1394 27.0902C66.1281 27.0204 66.0431 26.9905 65.9694 26.9819L65.9666 26.9933C65.9525 26.9933 65.9624 26.9577 65.9468 26.9548L65.9383 26.9691C65.9454 26.9491 65.9227 26.9491 65.927 26.9306L65.9015 26.9506L65.9086 26.9306C65.9185 26.8779 65.8632 26.9078 65.8547 26.8694L65.8491 26.8836C65.825 26.8309 65.774 26.8053 65.74 26.7696L65.7245 26.7981C65.7329 26.7753 65.723 26.7625 65.7131 26.754C65.6961 26.7682 65.706 26.7212 65.6834 26.7226V26.7283C65.6862 26.6998 65.6607 26.7312 65.6664 26.6998L65.6494 26.7112C65.6607 26.6813 65.6267 26.7169 65.6253 26.6998L65.6296 26.6913L65.6083 26.6827V26.6856C65.5913 26.6685 65.5743 26.6742 65.5885 26.6557C65.5687 26.6699 65.5998 26.6756 65.5757 26.6941C65.5318 26.6357 65.4724 26.603 65.4115 26.5745L65.3874 26.5887L65.369 26.5602L65.3548 26.5688C65.3378 26.5745 65.3548 26.5389 65.3378 26.5417L65.3308 26.5688C65.3308 26.5431 65.3152 26.5417 65.3053 26.5275L65.3038 26.5474C65.301 26.5175 65.2755 26.5389 65.2713 26.5203L65.2699 26.5346C65.2429 26.5431 65.2769 26.5047 65.2557 26.5075L65.2529 26.5246C65.2486 26.4919 65.2231 26.489 65.2118 26.4719L65.2061 26.4776L65.1608 26.4477C65.1509 26.4505 65.1452 26.4805 65.1311 26.4705C65.1466 26.4406 65.1084 26.442 65.1325 26.4178C65.1155 26.4149 65.0886 26.4121 65.0829 26.3978C65.0843 26.4121 65.0603 26.4263 65.073 26.4363L65.0532 26.4477C65.0518 26.4619 65.0659 26.4505 65.056 26.4648L65.0291 26.442C65.0263 26.4192 65.0305 26.3807 65.0135 26.3693L64.998 26.4035L64.9937 26.3423C64.9909 26.3366 64.9838 26.3622 64.9781 26.3537V26.3309C64.9725 26.3337 64.9526 26.3138 64.9427 26.3394L64.9356 26.3565L64.9158 26.3366V26.3423C64.9073 26.3423 64.896 26.3223 64.9116 26.3095C64.9186 26.3124 64.9045 26.3266 64.9144 26.3209C64.9158 26.3038 64.9045 26.2924 64.8917 26.2867L64.8889 26.3095L64.8549 26.254C64.8577 26.2397 64.8521 26.2796 64.8563 26.2739C64.828 26.2824 64.8209 26.2297 64.7912 26.2483L64.7983 26.234C64.7855 26.2312 64.7784 26.2511 64.7756 26.2397C64.7699 26.2511 64.7671 26.234 64.7586 26.2255C64.76 26.2169 64.7558 26.2312 64.7614 26.234C64.7544 26.2226 64.719 26.1898 64.6906 26.1955L64.6807 26.1656L64.6765 26.1827C64.6666 26.1884 64.6567 26.1742 64.6496 26.1884C64.6482 26.1599 64.6878 26.2212 64.6779 26.1998C64.6694 26.2141 64.6666 26.1642 64.6609 26.1884C64.651 26.1827 64.6467 26.1599 64.6326 26.1713C64.634 26.1742 64.6312 26.2027 64.6198 26.197L64.6099 26.1742L64.6043 26.1656C64.6085 26.1485 64.5887 26.1628 64.6014 26.1457C64.5929 26.1599 64.5816 26.1257 64.5717 26.1571L64.5688 26.1799L64.5618 26.1414L64.5561 26.1528C64.5674 26.1143 64.5377 26.1471 64.5405 26.1172C64.5221 26.1257 64.5037 26.1086 64.4881 26.1286L64.4598 26.1029L64.4626 26.1172L64.4456 26.1058C64.4456 26.1115 64.4216 26.1229 64.4102 26.1314L64.4145 26.0901C64.3947 26.1243 64.3904 26.0631 64.3692 26.0901L64.3678 26.1158C64.3465 26.1485 64.3536 26.0859 64.3338 26.0987L64.3451 26.0673C64.3323 26.0844 64.3253 26.0474 64.321 26.0759C64.3168 26.0645 64.2984 26.0816 64.3054 26.0531C64.2729 26.0702 64.2431 26.0232 64.2134 26.0673C64.212 26.0616 64.1992 26.0645 64.2049 26.0474C64.2148 26.036 64.212 26.0616 64.2176 26.0531L64.2148 26.0417C64.2049 26.0445 64.1964 26.0417 64.2006 26.0702C64.1766 26.0844 64.1907 26.0175 64.1652 26.0232L64.1553 26.0346L64.1468 26.0118C64.1312 26.0118 64.1298 26.0374 64.1256 26.0531L64.1058 26.0303L64.0902 26.0531C64.1029 26.036 64.0873 26.0388 64.0831 26.036L64.0873 26.0388H64.0704L64.0916 26.0189L64.0789 25.999C64.0774 26.0189 64.0619 26.0075 64.0562 26.0103L64.0491 25.9904C64.0449 25.999 64.035 25.9876 64.0378 26.0018L64.0477 26.0046C64.042 26.0132 64.0378 26.0303 64.0307 26.016C64.025 26.0018 64.042 25.9747 64.0236 25.9861L64.0265 26.0089L64.0109 26.0146L64.0123 25.9947L64.0095 26.0032C64.0095 25.9833 63.991 25.9918 63.991 25.969L63.9656 25.9804L63.967 25.9833C63.9556 25.9918 63.9471 25.9833 63.9401 25.9719L63.9217 25.9605C63.9089 25.9719 63.9047 26.0274 63.8962 26.0018C63.8834 25.9989 63.8834 25.9662 63.8905 25.9576C63.865 25.9662 63.848 25.932 63.8239 25.9576L63.8211 25.9405C63.7885 25.9462 63.7574 25.9092 63.7276 25.9434L63.7248 25.9733C63.7191 25.9534 63.7135 25.9876 63.7149 25.9591L63.7276 25.9291C63.7106 25.9177 63.6809 25.9149 63.671 25.9263L63.6682 25.9092C63.6653 25.9348 63.6526 25.9377 63.6441 25.9291V25.9121L63.6356 25.9291C63.6313 25.9234 63.6356 25.8935 63.6228 25.9092L63.6186 25.9234C63.6058 25.9092 63.5931 25.8878 63.5832 25.8978L63.5719 25.9206L63.5676 25.8964C63.5464 25.9106 63.5336 25.9078 63.528 25.9291C63.4968 25.8764 63.4458 25.8622 63.4062 25.8679L63.4076 25.8821C63.3948 25.8935 63.4005 25.8593 63.3948 25.8679L63.3906 25.9064C63.375 25.9206 63.3708 25.8836 63.3637 25.8807C63.3637 25.8665 63.3722 25.8921 63.3693 25.8722C63.3708 25.8636 63.3481 25.8807 63.3467 25.8579V25.8935L63.3368 25.885C63.3254 25.9106 63.3623 25.932 63.3495 25.969L63.341 25.9633C63.3297 25.989 63.3623 25.9904 63.341 25.999C63.3325 25.9876 63.324 25.9548 63.3325 25.9434C63.3127 25.9377 63.3254 25.8878 63.307 25.8878C63.2985 25.9049 63.3226 25.8907 63.3184 25.9135C63.3056 25.9334 63.2957 25.9021 63.2872 25.9106L63.2844 25.8693L63.2759 25.895C63.2716 25.8836 63.2603 25.8722 63.2702 25.8636C63.2645 25.8337 63.2561 25.8722 63.2447 25.8465C63.2419 25.8693 63.2617 25.8964 63.2447 25.9078C63.249 25.8878 63.2235 25.8807 63.2334 25.8522L63.232 25.885C63.2221 25.8964 63.2079 25.8494 63.2051 25.8878L63.2008 25.865L63.1881 25.8907C63.1796 25.8935 63.1626 25.8622 63.1626 25.8964C63.1612 25.8907 63.1413 25.8935 63.1484 25.8707C63.1612 25.8536 63.1626 25.885 63.1697 25.8565C63.1598 25.8807 63.1527 25.8536 63.1442 25.8451L63.1428 25.8565L63.1272 25.8422L63.1243 25.8593L63.1187 25.8422C63.1017 25.8309 63.1159 25.875 63.1017 25.8693L63.113 25.8836L63.0989 25.8921L63.0833 25.8422C63.0748 25.8337 63.0804 25.8622 63.0705 25.8451L63.0847 25.865C63.0861 25.8707 63.0776 25.8935 63.0635 25.8935C63.055 25.8878 63.0422 25.865 63.055 25.8522L63.045 25.8779C63.0309 25.8722 63.045 25.8579 63.0337 25.8479L63.0082 25.895L63.0224 25.9249L63.0153 25.922C63.028 25.9477 63.0111 25.942 63.0167 25.9662L63.0011 25.9548C63.0139 25.9135 62.9756 25.9021 62.9799 25.8636C62.9544 25.8551 62.9714 25.9534 62.9445 25.8964C62.9473 25.8878 62.9332 25.8608 62.9487 25.8707C62.936 25.8736 62.936 25.8351 62.9204 25.8479C62.9346 25.8622 62.9119 25.8836 62.9317 25.9092C62.9289 25.895 62.9402 25.895 62.9417 25.9007C62.9374 25.9121 62.9459 25.9363 62.9332 25.9391L62.9133 25.9135C62.9119 25.8907 62.9261 25.9135 62.9176 25.8935C62.8978 25.8878 62.8992 25.9192 62.8907 25.885C62.8992 25.885 62.9006 25.8622 62.8978 25.8494L62.885 25.8408L62.8893 25.8551C62.8694 25.8693 62.8808 25.8323 62.8595 25.838L62.8539 25.8679C62.8624 25.8907 62.8808 25.8508 62.8822 25.8907C62.8709 25.8964 62.8638 25.8736 62.8539 25.8878L62.8638 25.8935C62.8595 25.8935 62.8595 25.9462 62.8383 25.922L62.8326 25.8935L62.7915 25.8764C62.7972 25.9064 62.7661 25.885 62.7859 25.9121C62.7901 25.8921 62.8199 25.8893 62.8298 25.9149C62.827 25.9491 62.8439 25.9092 62.8539 25.9405C62.8354 25.9434 62.8411 25.9762 62.8425 25.9961L62.8284 25.9904V25.9462C62.8128 25.9576 62.7915 25.9491 62.7802 25.932L62.7859 25.9619L62.7236 25.9762C62.7321 25.9434 62.6981 25.9733 62.7037 25.9462C62.7137 25.9377 62.7207 25.9106 62.7108 25.8992L62.7122 25.9192C62.7009 25.9021 62.7023 25.9519 62.691 25.9249C62.7122 25.9306 62.6995 25.9633 62.708 25.9861C62.691 25.9747 62.7122 26.0061 62.6981 26.0089L62.6443 25.9861C62.6287 26.0132 62.5961 25.9975 62.5777 25.9975C62.5706 26.0146 62.582 26.0417 62.5735 26.0474C62.5635 26.0502 62.5763 26.0175 62.5607 26.0303L62.565 26.036C62.5565 26.0303 62.5352 26.0616 62.5239 26.0217L62.5366 26.0488L62.5253 26.0431L62.531 26.0702C62.5267 26.093 62.5097 26.0702 62.4998 26.0702L62.5041 26.0502C62.4786 26.0388 62.4701 26.0616 62.4517 26.0588L62.4545 26.073L62.4417 26.0673C62.4488 26.0844 62.4432 26.0972 62.4304 26.0844L62.4687 26.12L62.4559 26.0844C62.4573 26.0645 62.4757 26.0673 62.4814 26.0873L62.4701 26.0816C62.4715 26.1044 62.4828 26.1015 62.4927 26.1172H62.4828L62.5126 26.1286L62.5069 26.1058C62.5126 26.1257 62.5267 26.1286 62.538 26.1229C62.5423 26.0944 62.5692 26.1343 62.582 26.1229L62.5451 26.0816L62.5678 26.0645L62.5975 26.1115L62.5961 26.0944C62.6103 26.1029 62.6145 26.1257 62.6287 26.12L62.6981 26.0972L62.6967 26.0773C62.7151 26.1101 62.7363 26.0858 62.7547 26.0972C62.776 26.0773 62.81 26.1029 62.8199 26.0716L62.953 26.0745L62.9417 26.0488C62.953 26.0659 62.9459 26.0346 62.9558 26.0374C62.9459 26.0574 62.9686 26.0631 62.9742 26.0759C62.9941 26.0559 63.0238 26.0787 63.0422 26.0958L63.0436 26.0787C63.062 26.1101 63.0819 26.0787 63.1074 26.0759L63.1201 26.0531C63.1357 26.0816 63.1399 26.0787 63.1583 26.0972L63.2079 26.0773C63.2575 26.1129 63.3084 26.0887 63.3594 26.1115L63.3637 26.0915C63.4132 26.1272 63.477 26.1001 63.518 26.1272L63.5166 26.0915C63.5308 26.0859 63.5464 26.1058 63.5421 26.13C63.5563 26.1215 63.5747 26.15 63.5846 26.1243L63.6101 26.1471C63.637 26.1386 63.6483 26.1414 63.6738 26.1528H63.6653L63.6724 26.13C63.6823 26.1414 63.7106 26.1272 63.6951 26.1628C63.7291 26.1457 63.7574 26.1913 63.79 26.1628L63.7928 26.1827C63.8183 26.1856 63.8466 26.1685 63.8636 26.1913L63.8721 26.1713L63.8735 26.1913C63.9103 26.2141 63.9585 26.1856 63.991 26.1998C64.0491 26.2354 64.1157 26.2411 64.1766 26.2611L64.178 26.2525C64.1893 26.2881 64.2332 26.2354 64.236 26.2853C64.2417 26.2767 64.2545 26.2853 64.2559 26.2682C64.2672 26.291 64.3069 26.2625 64.3238 26.2938L64.3196 26.2881C64.3479 26.2739 64.3607 26.3052 64.3876 26.2967L64.3862 26.2796C64.4003 26.2682 64.3989 26.3181 64.4145 26.2824L64.4088 26.2995C64.4683 26.3024 64.515 26.3494 64.566 26.3779C64.6113 26.3693 64.5901 26.3195 64.6085 26.3579L64.6099 26.3636C64.6198 26.3779 64.6425 26.3309 64.6439 26.3522C64.6326 26.3722 64.6467 26.3665 64.6411 26.3807C64.6708 26.375 64.6821 26.3551 64.6949 26.3807L64.6977 26.3665C64.7062 26.4078 64.7388 26.4021 64.743 26.4477C64.8634 26.4947 64.9668 26.5674 65.0758 26.6315L65.4129 26.7896C65.4525 26.7782 65.454 26.781 65.4752 26.8124L65.4809 26.7981C65.4695 26.8238 65.5007 26.8152 65.4908 26.8395L65.6027 26.9121C65.5998 26.9064 65.6083 26.8865 65.6154 26.8922L65.6126 26.9121L65.6197 26.9064L65.6112 26.9306C65.7004 27.0147 65.8335 27.0275 65.9213 27.1115C65.9482 27.1201 65.9765 27.1529 65.9978 27.1757C66.0912 27.2013 66.1762 27.2284 66.2329 27.3039C66.2612 27.3067 66.2994 27.2483 66.2753 27.2127Z",
    fill: "#67472D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5487 23.3948C53.5298 20.6924 57.2883 18.4116 57.9865 17.8974C57.9865 17.8974 53.915 17.1039 49.1962 17.7107C44.4804 18.3205 45.4505 18.5099 41.1934 22.3691C36.9421 26.2312 36.5993 27.7369 35.5896 30.4493C34.5799 33.156 32.7318 41.2334 31.6994 43.6011C31.7277 43.829 31.8084 44.48 31.9458 44.9729C32.0747 45.0014 34.5728 45.4374 40.406 39.5894C40.6142 38.9997 41.6523 36.1705 43.4876 32.9623C45.5496 29.3524 47.5705 26.0972 50.5487 23.3948Z",
    fill: "#E80C0C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M49.175 21.5372C49.175 21.5372 44.7778 24.0772 42.7583 30.6687C42.7583 30.6687 43.6661 24.261 49.175 21.5372Z",
    fill: "#AD071C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4053 25.0616C44.4053 25.0616 39.596 32.0762 40.6482 37.491C40.6468 37.491 38.6825 32.5848 44.4053 25.0616Z",
    fill: "#AD071C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7608 29.0105C54.7774 26.7312 56.1412 25.5488 57.4101 24.8365C58.0417 24.4832 58.6506 24.2467 59.3077 24.0459C61.2026 23.4803 61.7606 23.013 62.5083 22.9076C62.5041 22.9048 62.5041 22.9019 62.5041 22.9019C62.5041 22.9019 64.178 22.4517 63.9386 21.597C63.6993 20.7394 62.4148 20.3704 60.9491 19.7579C59.4805 19.1453 59.4026 18.0128 57.0079 17.621C54.6103 17.2292 54.48 18.0028 54.48 18.0028C53.8739 18.47 50.468 20.5043 48.0137 22.9689C45.5581 25.4362 44.2849 28.4592 43.0614 31.8198C41.9709 34.8057 41.6367 37.4597 41.5744 38.0139C41.5815 38.0053 41.5885 37.9996 41.5942 37.9911L42.1649 38.9783C42.4113 38.9056 43.8303 38.4327 45.8371 36.7802C45.8356 36.7816 49.3563 32.8669 52.7608 29.0105Z",
    fill: "url(#paint1_linear_2436_51438)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2963 44.3048L37.027 44.48L37.3457 44.839L36.9789 45.2821L37.3712 45.6852L36.1079 45.9402L37.0964 46.4858L36.1717 46.6055L35.6831 46.748L36.0853 47.3021L36.4322 47.9631L35.38 47.6155L35.2228 47.8891L34.992 48.1027L35.0996 48.8122L34.6733 48.8065L34.1111 48.3976L34.2046 49.5971L33.7287 49.3193L33.3903 49.5131L33.0235 49.5772L32.627 50.0202L32.3352 49.0658L31.8481 49.7111L31.6172 49.1356L31.4388 48.6655L31.0918 48.6341L30.9105 48.3136L30.5806 48.2196L29.6261 48.7239L30.2903 47.6184L29.3613 47.8891L30.0793 47.0372L28.6461 47.3577L29.3273 46.6782L29.0823 46.3861L28.8897 46.0528L28.799 45.6881L28.3359 45.292L28.7197 44.9259L29.3018 44.6695L29.3655 44.3362L29.391 43.98L29.5369 43.6623L29.7054 43.356L29.4958 42.7307L30.5622 43.2307L30.81 43.0697L30.4475 42.0255L31.1725 42.5355L31.1924 41.8061L31.7121 42.1964L31.7914 41.1437L32.2318 41.3274L32.6029 41.0083L32.9583 42.3289L33.3563 41.5425L33.5234 42.44L33.9454 42.0796L34.349 41.9785L34.4595 42.507L35.3177 41.8004L35.4466 42.2876L35.0302 43.2535L35.7865 42.997L36.3572 43.0355L36.2297 43.5655L35.9408 44.0911L36.2963 44.3048Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8992 44.9915C31.004 44.1852 31.351 43.7478 31.7404 43.517C31.249 43.6951 30.7477 44.1239 30.6202 45.1225C30.3951 46.8619 31.8693 48.4062 33.2175 47.6098C31.9529 48.0614 30.6882 46.6084 30.8992 44.9915Z",
    fill: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2436_51438)"
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1333 106.394C59.2662 106.445 58.0375 105.643 58.0804 104.546C58.1246 103.449 58.1246 103.159 57.2917 102.352C56.4587 101.545 56.6773 100.677 55.7129 100.446C54.7485 100.214 53.3012 100.273 53.0826 99.9829C53.0826 99.9829 52.5568 97.6155 50.3638 97.8452C50.3638 97.8452 49.4436 94.9001 48.0835 95.3612C48.0835 95.3612 46.7677 94.4955 45.1889 95.2463C43.6102 95.9972 43.523 98.0766 43.6545 99.0006C43.7859 99.9246 43.4358 100.329 43.0401 99.8663C42.6458 99.4034 42.4258 97.96 40.6284 98.5377C38.8311 99.1154 38.1295 96.3435 36.5065 96.6897C34.8835 97.036 36.2879 98.4794 34.2706 97.9035C32.2532 97.3258 30.9816 96.5749 30.9387 98.5395C30.8945 100.502 29.9743 100.446 29.4914 101.948C29.0085 103.449 29.0971 105.47 29.4914 106.048C29.8858 106.626 30.0615 113.325 30.3687 109.861C30.6758 106.396 30.7201 105.124 31.2016 105.587C31.6845 106.05 31.3331 105.299 32.0346 104.951C32.7361 104.603 34.2706 102.121 34.0519 104.315C33.8333 106.509 34.1834 111.246 34.3148 108.82C34.4463 106.394 34.2706 102.872 35.1478 103.159C36.025 103.447 37.0337 104.198 36.2436 105.758C35.455 107.318 36.8137 108.472 36.5065 109.398C36.1994 110.322 36.638 109.427 36.638 112.43C36.638 115.434 37.3395 113.932 37.5152 105.673C37.5844 102.427 38.9625 104.027 39.0497 105.99C39.1368 107.953 39.7512 110.899 40.1455 109.513C40.5399 108.126 40.9342 102.582 41.2856 103.852C41.6371 105.122 42.5572 106.163 42.9087 104.949C43.2601 103.735 43.523 102.638 44.0045 103.794C44.4874 104.949 43.5659 112.283 44.4431 112.168C45.3204 112.053 44.1802 107.029 44.926 104.718C45.6718 102.407 46.2419 103.158 46.329 103.852C46.4162 104.545 46.4605 107.779 47.2063 106.741C47.9521 105.702 47.382 102.928 48.0392 103.449C48.6965 103.969 48.7407 106.626 49.3551 105.99C49.9694 105.354 49.5308 103.101 50.2752 103.276C51.021 103.449 50.7581 105.875 51.634 105.124C52.5112 104.373 52.9055 102.525 53.3441 103.449C53.7828 104.373 54.0014 103.508 54.5714 104.2C55.1415 104.893 55.6673 105.99 55.2287 106.511C54.7901 107.032 55.6673 108.705 55.5801 109.688C55.4929 110.67 56.063 112.691 56.063 111.362C56.063 110.034 56.063 108.186 56.4145 107.435C56.7659 106.684 57.1602 106.165 57.3346 106.742C57.5103 107.32 57.4218 108.532 57.686 108.937C57.9489 109.341 57.7732 111.248 58.0804 110.553C58.3875 109.861 58.2118 106.048 59.1333 106.394Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 94,
    width: 31,
    height: 20
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1333 106.394C59.2662 106.445 58.0375 105.643 58.0804 104.546C58.1246 103.449 58.1246 103.159 57.2917 102.352C56.4587 101.545 56.6773 100.677 55.7129 100.446C54.7485 100.214 53.3012 100.273 53.0826 99.9829C53.0826 99.9829 52.5568 97.6155 50.3638 97.8452C50.3638 97.8452 49.4436 94.9001 48.0835 95.3612C48.0835 95.3612 46.7677 94.4955 45.1889 95.2463C43.6102 95.9972 43.523 98.0766 43.6545 99.0006C43.7859 99.9246 43.4358 100.329 43.0401 99.8663C42.6458 99.4034 42.4258 97.96 40.6284 98.5377C38.8311 99.1154 38.1295 96.3435 36.5065 96.6897C34.8835 97.036 36.2879 98.4794 34.2706 97.9035C32.2532 97.3258 30.9816 96.5749 30.9387 98.5395C30.8945 100.502 29.9743 100.446 29.4914 101.948C29.0085 103.449 29.0971 105.47 29.4914 106.048C29.8858 106.626 30.0615 113.325 30.3687 109.861C30.6758 106.396 30.7201 105.124 31.2016 105.587C31.6845 106.05 31.3331 105.299 32.0346 104.951C32.7361 104.603 34.2706 102.121 34.0519 104.315C33.8333 106.509 34.1834 111.246 34.3148 108.82C34.4463 106.394 34.2706 102.872 35.1478 103.159C36.025 103.447 37.0337 104.198 36.2436 105.758C35.455 107.318 36.8137 108.472 36.5065 109.398C36.1994 110.322 36.638 109.427 36.638 112.43C36.638 115.434 37.3395 113.932 37.5152 105.673C37.5844 102.427 38.9625 104.027 39.0497 105.99C39.1368 107.953 39.7512 110.899 40.1455 109.513C40.5399 108.126 40.9342 102.582 41.2856 103.852C41.6371 105.122 42.5572 106.163 42.9087 104.949C43.2601 103.735 43.523 102.638 44.0045 103.794C44.4874 104.949 43.5659 112.283 44.4431 112.168C45.3204 112.053 44.1802 107.029 44.926 104.718C45.6718 102.407 46.2419 103.158 46.329 103.852C46.4162 104.545 46.4605 107.779 47.2063 106.741C47.9521 105.702 47.382 102.928 48.0392 103.449C48.6965 103.969 48.7407 106.626 49.3551 105.99C49.9694 105.354 49.5308 103.101 50.2752 103.276C51.021 103.449 50.7581 105.875 51.634 105.124C52.5112 104.373 52.9055 102.525 53.3441 103.449C53.7828 104.373 54.0014 103.508 54.5714 104.2C55.1415 104.893 55.6673 105.99 55.2287 106.511C54.7901 107.032 55.6673 108.705 55.5801 109.688C55.4929 110.67 56.063 112.691 56.063 111.362C56.063 110.034 56.063 108.186 56.4145 107.435C56.7659 106.684 57.1602 106.165 57.3346 106.742C57.5103 107.32 57.4218 108.532 57.686 108.937C57.9489 109.341 57.7732 111.248 58.0804 110.553C58.3875 109.861 58.2118 106.048 59.1333 106.394Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M58.4761 105.153C58.4761 105.153 58.2575 104.749 57.5559 104.98C56.8544 105.212 56.3287 104.229 56.3287 103.305C56.3287 102.381 57.4245 101.399 56.4158 101.516C55.4071 101.631 54.0913 102.152 53.6541 101.457C53.2154 100.765 52.6897 101.631 52.1639 101.169C51.6381 100.707 51.6381 99.3798 50.3222 99.1483C49.0064 98.9169 47.1648 95.2209 46.4632 97.242C45.7617 99.2631 44.6659 99.3215 43.6572 99.0044C42.6485 98.6873 44.403 101.691 43.3943 102.21C42.3856 102.729 41.9913 100.189 40.6326 100.996C39.2738 101.805 37.3879 97.5318 36.2478 99.0335C35.1076 100.535 35.6777 102.961 33.9675 101.747C32.2573 100.533 32.0816 103.076 31.1172 102.152C30.1528 101.228 28.837 100.592 28.3983 101.286C27.9597 101.979 26.7753 110.238 26.7753 110.238L34.0104 115.899L44.7088 118.151L61.1507 114.047L63.1237 108.561L58.4761 105.153Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M59.1333 105.268C58.9576 105.326 58.0804 105.614 58.1246 107.231C58.1689 108.847 57.9932 107.519 57.6417 106.307C57.2903 105.095 56.5888 105.788 56.3259 106.653C56.063 107.519 55.5801 108.386 55.6244 106.999C55.6687 105.613 55.7558 104.342 54.9671 103.823C54.1785 103.304 53.9142 103.765 53.5641 102.957C53.2127 102.148 52.6869 102.206 52.2054 103.13C51.7225 104.054 51.6796 104.517 51.1095 103.13C50.5395 101.744 49.3551 103.881 48.8293 103.362C48.3035 102.842 48.6978 101.629 49.618 101.629C50.5381 101.629 50.6709 101.282 51.2839 101.514C51.8968 101.745 51.9411 100.244 51.1967 100.358C50.4509 100.473 49.618 100.3 49.3993 99.6659C49.1807 99.0299 47.9963 97.7031 47.382 98.8002C46.7676 99.8974 47.2505 101.284 46.5048 101.111C45.759 100.938 45.2332 105.326 44.4002 103.305C43.5673 101.284 42.91 105.268 42.1642 104.171C41.4185 103.074 40.5412 101.977 40.2783 104.344C40.0154 106.712 39.8397 107.348 39.4011 104.69C38.9625 102.033 37.9109 104.632 37.2523 103.766C36.5951 102.901 35.2349 102.033 34.622 102.611C34.0076 103.189 33.4819 101.975 32.8675 102.899C32.2532 103.823 31.6831 105.729 30.9387 104.632C30.1929 103.535 29.4914 105.037 29.7986 103.477C30.1058 101.917 28.7027 100.993 29.36 100.185C30.0172 99.3761 26.5539 103.766 26.5539 103.766L25.5895 112.141L34.1405 119.822L52.2497 117.743L62.598 115.376L59.1333 105.268Z",
    fill: "url(#paint2_linear_2436_51438)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2436_51438)"
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M110.383 104.551C110.653 104.602 108.151 103.801 108.238 102.703C108.328 101.606 108.328 101.316 106.632 100.509C104.936 99.7018 105.381 98.8343 103.417 98.6028C101.453 98.3714 98.5052 98.4297 98.06 98.1399C98.06 98.1399 96.9891 95.7726 92.5227 96.0022C92.5227 96.0022 90.6488 93.0571 87.8788 93.5182C87.8788 93.5182 85.199 92.6525 81.9837 93.4034C78.7685 94.1542 78.591 96.2336 78.8587 97.1576C79.1264 98.0816 78.4134 98.4862 77.6075 98.0233C76.8044 97.5604 76.3564 96.117 72.6959 96.6947C69.0354 97.2724 67.6067 94.5005 64.3013 94.8467C60.9959 95.193 63.8561 96.6364 59.7476 96.0605C55.639 95.4828 53.0494 94.7319 52.962 96.6965C52.8718 98.6593 50.9979 98.6028 50.0145 100.105C49.031 101.606 49.2114 103.627 50.0145 104.205C50.8176 104.783 51.1755 111.482 51.801 108.018C52.4266 104.553 52.5168 103.281 53.4974 103.744C54.4809 104.207 53.7651 103.456 55.1938 103.108C56.6225 102.76 59.7476 100.278 59.3023 102.472C58.8571 104.666 59.57 109.403 59.8377 106.977C60.1054 104.551 59.7476 101.029 61.5341 101.316C63.3207 101.604 65.3749 102.355 63.7659 103.915C62.1597 105.475 64.9269 106.629 64.3013 107.555C63.6757 108.479 64.569 107.584 64.569 110.587C64.569 113.591 65.9977 112.089 66.3556 103.83C66.4965 100.584 69.3031 102.184 69.4806 104.147C69.6582 106.11 70.9093 109.056 71.7124 107.67C72.5155 106.283 73.3186 100.739 74.0344 102.009C74.7501 103.279 76.6241 104.32 77.3398 103.106C78.0556 101.892 78.591 100.795 79.5716 101.951C80.5551 103.106 78.6783 110.44 80.4649 110.325C82.2514 110.21 79.9295 105.186 81.4483 102.875C82.9672 100.564 84.1282 101.315 84.3057 102.009C84.4832 102.702 84.5734 105.936 86.0923 104.898C87.6111 103.859 86.4501 101.085 87.7886 101.606C89.1272 102.126 89.2173 104.783 90.4685 104.147C91.7196 103.511 90.8264 101.258 92.3424 101.433C93.8613 101.606 93.3259 104.032 95.1096 103.281C96.8962 102.53 97.6993 100.682 98.5925 101.606C99.4858 102.53 99.931 101.665 101.092 102.357C102.253 103.05 103.324 104.147 102.431 104.668C101.537 105.189 103.324 106.862 103.146 107.845C102.969 108.827 104.13 110.848 104.13 109.519C104.13 108.191 104.13 106.343 104.845 105.592C105.561 104.841 106.364 104.322 106.719 104.899C107.077 105.477 106.897 106.689 107.435 107.094C107.971 107.498 107.613 109.405 108.238 108.71C108.864 108.018 108.506 104.205 110.383 104.551Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 93,
    width: 62,
    height: 20
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M110.383 104.551C110.653 104.602 108.151 103.801 108.238 102.703C108.328 101.606 108.328 101.316 106.632 100.509C104.936 99.7018 105.381 98.8343 103.417 98.6028C101.453 98.3714 98.5052 98.4297 98.06 98.1399C98.06 98.1399 96.9891 95.7726 92.5227 96.0022C92.5227 96.0022 90.6488 93.0571 87.8788 93.5182C87.8788 93.5182 85.199 92.6525 81.9837 93.4034C78.7685 94.1542 78.591 96.2336 78.8587 97.1576C79.1264 98.0816 78.4134 98.4862 77.6075 98.0233C76.8044 97.5604 76.3564 96.117 72.6959 96.6947C69.0354 97.2724 67.6067 94.5005 64.3013 94.8467C60.9959 95.193 63.8561 96.6364 59.7476 96.0605C55.639 95.4828 53.0494 94.7319 52.962 96.6965C52.8718 98.6593 50.9979 98.6028 50.0145 100.105C49.031 101.606 49.2114 103.627 50.0145 104.205C50.8176 104.783 51.1755 111.482 51.801 108.018C52.4266 104.553 52.5168 103.281 53.4974 103.744C54.4809 104.207 53.7651 103.456 55.1938 103.108C56.6225 102.76 59.7476 100.278 59.3023 102.472C58.8571 104.666 59.57 109.403 59.8377 106.977C60.1054 104.551 59.7476 101.029 61.5341 101.316C63.3207 101.604 65.3749 102.355 63.7659 103.915C62.1597 105.475 64.9269 106.629 64.3013 107.555C63.6757 108.479 64.569 107.584 64.569 110.587C64.569 113.591 65.9977 112.089 66.3556 103.83C66.4965 100.584 69.3031 102.184 69.4806 104.147C69.6582 106.11 70.9093 109.056 71.7124 107.67C72.5155 106.283 73.3186 100.739 74.0344 102.009C74.7501 103.279 76.6241 104.32 77.3398 103.106C78.0556 101.892 78.591 100.795 79.5716 101.951C80.5551 103.106 78.6783 110.44 80.4649 110.325C82.2514 110.21 79.9295 105.186 81.4483 102.875C82.9672 100.564 84.1282 101.315 84.3057 102.009C84.4832 102.702 84.5734 105.936 86.0923 104.898C87.6111 103.859 86.4501 101.085 87.7886 101.606C89.1272 102.126 89.2173 104.783 90.4685 104.147C91.7196 103.511 90.8264 101.258 92.3424 101.433C93.8613 101.606 93.3259 104.032 95.1096 103.281C96.8962 102.53 97.6993 100.682 98.5925 101.606C99.4858 102.53 99.931 101.665 101.092 102.357C102.253 103.05 103.324 104.147 102.431 104.668C101.537 105.189 103.324 106.862 103.146 107.845C102.969 108.827 104.13 110.848 104.13 109.519C104.13 108.191 104.13 106.343 104.845 105.592C105.561 104.841 106.364 104.322 106.719 104.899C107.077 105.477 106.897 106.689 107.435 107.094C107.971 107.498 107.613 109.405 108.238 108.71C108.864 108.018 108.506 104.205 110.383 104.551Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M109.044 103.31C109.044 103.31 108.599 102.906 107.17 103.137C105.742 103.369 104.671 102.386 104.671 101.462C104.671 100.538 106.903 99.5561 104.848 99.6727C102.794 99.7875 100.114 100.309 99.2238 99.6144C98.3305 98.9219 97.2597 99.7875 96.1889 99.3265C95.1181 98.8636 95.1181 97.5368 92.4382 97.3053C89.7584 97.0739 86.0077 93.3779 84.579 95.3991C83.1504 97.4202 80.9186 97.4785 78.8643 97.1614C76.81 96.8443 80.3832 99.8477 78.3289 100.367C76.2746 100.886 75.4715 98.346 72.7043 99.1533C69.9371 99.9625 66.0963 95.6888 63.7744 97.1905C61.4524 98.6922 62.6134 101.118 59.1304 99.9042C55.6475 98.6904 55.2896 101.233 53.3255 100.309C51.3614 99.3848 48.6816 98.7487 47.7883 99.4431C46.895 100.136 44.4829 108.395 44.4829 108.395L59.2178 114.056L81.0059 116.308L114.491 112.204L118.51 106.718L109.044 103.31Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M110.383 103.425C110.025 103.483 108.238 103.771 108.328 105.388C108.419 107.004 108.061 105.676 107.345 104.464C106.629 103.252 105.201 103.945 104.665 104.81C104.13 105.676 103.146 106.543 103.236 105.157C103.327 103.77 103.504 102.499 101.898 101.98C100.292 101.461 99.7535 101.922 99.0406 101.114C98.3249 100.305 97.254 100.363 96.2734 101.287C95.29 102.211 95.2026 102.674 94.0416 101.287C92.8806 99.9005 90.4685 102.038 89.3977 101.519C88.3269 100.999 89.13 99.7857 91.0039 99.7857C92.8778 99.7857 93.1483 99.4394 94.3967 99.6709C95.645 99.9023 95.7352 98.4006 94.2191 98.5154C92.7003 98.6303 91.0039 98.4571 90.5587 97.8229C90.1134 97.1869 87.7013 95.8601 86.4502 96.9572C85.199 98.0544 86.1824 99.4413 84.6636 99.2681C83.1447 99.095 82.0739 103.483 80.3775 101.462C78.6812 99.4413 77.3426 103.425 75.8238 102.328C74.3049 101.231 72.5184 100.134 71.983 102.501C71.4476 104.869 71.0897 105.505 70.1964 102.847C69.3031 100.19 67.1615 102.789 65.8202 101.923C64.4817 101.058 61.7117 100.19 60.4633 100.768C59.2122 101.346 58.1414 100.132 56.8902 101.056C55.639 101.98 54.4781 103.886 52.962 102.789C51.4432 101.692 50.0145 103.194 50.6401 101.634C51.2656 100.074 48.4083 99.1497 49.7468 98.3423C51.0853 97.5331 44.032 101.923 44.032 101.923L42.068 110.298L59.4827 117.979L96.3636 115.9L117.439 113.533L110.383 103.425Z",
    fill: "url(#paint3_linear_2436_51438)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2436_51438)"
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M183.105 109.086C183.408 109.14 180.606 108.279 180.703 107.101C180.804 105.922 180.804 105.611 178.905 104.744C177.005 103.877 177.504 102.945 175.305 102.697C173.105 102.448 169.805 102.511 169.306 102.199C169.306 102.199 168.107 99.6566 163.106 99.9032C163.106 99.9032 161.007 96.74 157.906 97.2352C157.906 97.2352 154.905 96.3054 151.305 97.1119C147.704 97.9184 147.506 100.152 147.805 101.144C148.105 102.137 147.307 102.571 146.404 102.074C145.505 101.577 145.003 100.027 140.904 100.647C136.806 101.268 135.206 98.2903 131.505 98.6622C127.803 99.0341 131.006 100.584 126.405 99.9659C121.805 99.3454 118.905 98.5389 118.807 100.649C118.706 102.757 116.608 102.697 115.507 104.309C114.406 105.922 114.607 108.093 115.507 108.714C116.406 109.334 116.807 116.53 117.507 112.809C118.208 109.088 118.309 107.721 119.407 108.219C120.508 108.716 119.707 107.909 121.306 107.535C122.906 107.161 126.405 104.495 125.907 106.852C125.408 109.209 126.207 114.296 126.506 111.691C126.806 109.086 126.405 105.302 128.406 105.611C130.407 105.92 132.707 106.727 130.905 108.403C129.106 110.078 132.205 111.317 131.505 112.312C130.804 113.304 131.804 112.343 131.804 115.569C131.804 118.795 133.404 117.182 133.805 108.311C133.963 104.824 137.105 106.543 137.304 108.651C137.503 110.759 138.904 113.925 139.803 112.435C140.703 110.945 141.602 104.991 142.403 106.355C143.205 107.719 145.303 108.837 146.105 107.533C146.906 106.23 147.506 105.051 148.604 106.292C149.705 107.533 147.603 115.41 149.604 115.287C151.604 115.164 149.004 109.767 150.705 107.285C152.406 104.803 153.706 105.609 153.905 106.355C154.104 107.099 154.204 110.573 155.905 109.458C157.606 108.342 156.306 105.363 157.805 105.922C159.304 106.48 159.405 109.334 160.806 108.651C162.207 107.968 161.206 105.549 162.904 105.736C164.605 105.922 164.005 108.528 166.002 107.721C168.003 106.915 168.902 104.93 169.903 105.922C170.903 106.915 171.401 105.985 172.701 106.729C174.001 107.473 175.2 108.651 174.2 109.211C173.2 109.771 175.2 111.568 175.002 112.623C174.803 113.678 176.103 115.849 176.103 114.422C176.103 112.995 176.103 111.01 176.904 110.203C177.706 109.397 178.605 108.839 179.003 109.46C179.403 110.08 179.201 111.382 179.804 111.816C180.404 112.251 180.003 114.298 180.703 113.553C181.404 112.809 181.003 108.714 183.105 109.086Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 96,
    width: 70,
    height: 22
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M183.105 109.086C183.408 109.14 180.606 108.279 180.703 107.101C180.804 105.922 180.804 105.611 178.905 104.744C177.005 103.877 177.504 102.945 175.305 102.697C173.105 102.448 169.805 102.511 169.306 102.199C169.306 102.199 168.107 99.6566 163.106 99.9032C163.106 99.9032 161.007 96.74 157.906 97.2352C157.906 97.2352 154.905 96.3054 151.305 97.1119C147.704 97.9184 147.506 100.152 147.805 101.144C148.105 102.137 147.307 102.571 146.404 102.074C145.505 101.577 145.003 100.027 140.904 100.647C136.806 101.268 135.206 98.2903 131.505 98.6622C127.803 99.0341 131.006 100.584 126.405 99.9659C121.805 99.3454 118.905 98.5389 118.807 100.649C118.706 102.757 116.608 102.697 115.507 104.309C114.406 105.922 114.607 108.093 115.507 108.714C116.406 109.334 116.807 116.53 117.507 112.809C118.208 109.088 118.309 107.721 119.407 108.219C120.508 108.716 119.707 107.909 121.306 107.535C122.906 107.161 126.405 104.495 125.907 106.852C125.408 109.209 126.207 114.296 126.506 111.691C126.806 109.086 126.405 105.302 128.406 105.611C130.407 105.92 132.707 106.727 130.905 108.403C129.106 110.078 132.205 111.317 131.505 112.312C130.804 113.304 131.804 112.343 131.804 115.569C131.804 118.795 133.404 117.182 133.805 108.311C133.963 104.824 137.105 106.543 137.304 108.651C137.503 110.759 138.904 113.925 139.803 112.435C140.703 110.945 141.602 104.991 142.403 106.355C143.205 107.719 145.303 108.837 146.105 107.533C146.906 106.23 147.506 105.051 148.604 106.292C149.705 107.533 147.603 115.41 149.604 115.287C151.604 115.164 149.004 109.767 150.705 107.285C152.406 104.803 153.706 105.609 153.905 106.355C154.104 107.099 154.204 110.573 155.905 109.458C157.606 108.342 156.306 105.363 157.805 105.922C159.304 106.48 159.405 109.334 160.806 108.651C162.207 107.968 161.206 105.549 162.904 105.736C164.605 105.922 164.005 108.528 166.002 107.721C168.003 106.915 168.902 104.93 169.903 105.922C170.903 106.915 171.401 105.985 172.701 106.729C174.001 107.473 175.2 108.651 174.2 109.211C173.2 109.771 175.2 111.568 175.002 112.623C174.803 113.678 176.103 115.849 176.103 114.422C176.103 112.995 176.103 111.01 176.904 110.203C177.706 109.397 178.605 108.839 179.003 109.46C179.403 110.08 179.201 111.382 179.804 111.816C180.404 112.251 180.003 114.298 180.703 113.553C181.404 112.809 181.003 108.714 183.105 109.086Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M181.606 107.753C181.606 107.753 181.107 107.318 179.508 107.567C177.908 107.815 176.709 106.76 176.709 105.768C176.709 104.775 179.208 103.72 176.907 103.846C174.607 103.969 171.606 104.529 170.609 103.783C169.609 103.039 168.41 103.969 167.211 103.474C166.012 102.977 166.012 101.551 163.011 101.303C160.01 101.054 155.811 97.0846 154.211 99.2554C152.611 101.426 150.112 101.489 147.812 101.148C145.511 100.808 149.512 104.034 147.212 104.591C144.912 105.149 144.013 102.421 140.914 103.288C137.815 104.157 133.515 99.5666 130.914 101.18C128.314 102.793 129.614 105.398 125.714 104.094C121.814 102.791 121.414 105.521 119.214 104.529C117.015 103.536 114.014 102.853 113.014 103.599C112.014 104.343 109.313 113.214 109.313 113.214L125.812 119.294L150.21 121.713L187.705 117.305L192.205 111.413L181.606 107.753Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M183.105 107.876C182.704 107.939 180.703 108.248 180.804 109.984C180.905 111.721 180.505 110.294 179.703 108.992C178.902 107.69 177.302 108.434 176.702 109.364C176.103 110.294 175.002 111.225 175.103 109.736C175.204 108.246 175.402 106.882 173.604 106.324C171.805 105.766 171.203 106.261 170.404 105.394C169.603 104.525 168.404 104.588 167.306 105.58C166.204 106.572 166.107 107.07 164.807 105.58C163.507 104.09 160.806 106.386 159.606 105.829C158.407 105.271 159.307 103.967 161.405 103.967C163.503 103.967 163.806 103.595 165.204 103.844C166.602 104.092 166.703 102.479 165.005 102.603C163.305 102.726 161.405 102.54 160.907 101.859C160.408 101.176 157.707 99.7506 156.306 100.929C154.905 102.107 156.006 103.597 154.305 103.411C152.605 103.225 151.406 107.939 149.506 105.768C147.607 103.597 146.108 107.876 144.407 106.698C142.706 105.519 140.706 104.341 140.106 106.884C139.507 109.426 139.106 110.11 138.106 107.256C137.105 104.402 134.707 107.193 133.205 106.263C131.707 105.333 128.605 104.402 127.207 105.022C125.806 105.643 124.607 104.339 123.206 105.331C121.805 106.324 120.505 108.371 118.807 107.193C117.107 106.015 115.507 107.627 116.207 105.952C116.908 104.276 113.708 103.284 115.207 102.417C116.706 101.548 108.808 106.263 108.808 106.263L106.609 115.258L126.109 123.508L167.407 121.275L191.006 118.732L183.105 107.876Z",
    fill: "url(#paint4_linear_2436_51438)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2436_51438)"
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M103.059 109.62C103.329 109.671 100.827 108.869 100.915 107.772C101.005 106.674 101.005 106.385 99.3083 105.577C97.6119 104.77 98.0572 103.903 96.0931 103.671C94.129 103.44 91.1815 103.498 90.7362 103.208C90.7362 103.208 89.6654 100.841 85.199 101.07C85.199 101.07 83.3251 98.1253 80.5551 98.5864C80.5551 98.5864 77.8752 97.7207 74.66 98.4716C71.4448 99.2224 71.2672 101.302 71.5349 102.226C71.8026 103.15 71.0897 103.554 70.2838 103.092C69.4807 102.629 69.0326 101.185 65.3722 101.763C61.7117 102.341 60.283 99.5687 56.9776 99.915C53.6722 100.261 56.5323 101.705 52.4238 101.129C48.3153 100.551 45.7256 99.8001 45.6383 101.765C45.5481 103.728 43.6742 103.671 42.6907 105.173C41.7073 106.674 41.8876 108.696 42.6907 109.273C43.4938 109.851 43.8517 116.55 44.4773 113.086C45.1029 109.621 45.1931 108.349 46.1737 108.812C47.1571 109.275 46.4414 108.524 47.8701 108.176C49.2988 107.828 52.4238 105.346 51.9786 107.54C51.5334 109.734 52.2463 114.471 52.514 112.045C52.7817 109.62 52.4238 106.097 54.2104 106.385C55.9969 106.673 58.0512 107.423 56.4422 108.984C54.836 110.544 57.6032 111.697 56.9776 112.623C56.352 113.547 57.2453 112.652 57.2453 115.656C57.2453 118.659 58.674 117.157 59.0318 108.898C59.1727 105.652 61.9794 107.252 62.1569 109.215C62.3344 111.178 63.5856 114.125 64.3887 112.738C65.1918 111.351 65.9949 105.807 66.7107 107.077C67.4264 108.347 69.3003 109.388 70.0161 108.174C70.7318 106.961 71.2672 105.863 72.2479 107.019C73.2313 108.174 71.3546 115.508 73.1411 115.393C74.9277 115.278 72.6057 110.254 74.1246 107.943C75.6435 105.632 76.8044 106.383 76.982 107.077C77.1595 107.77 77.2497 111.005 78.7685 109.966C80.2874 108.927 79.1264 106.153 80.4649 106.674C81.8034 107.194 81.8936 109.851 83.1448 109.215C84.3959 108.579 83.5026 106.326 85.0187 106.501C86.5375 106.674 86.0021 109.1 87.7859 108.349C89.5724 107.598 90.3755 105.75 91.2688 106.674C92.1621 107.598 92.6073 106.733 93.7683 107.425C94.9293 108.118 96.0001 109.215 95.1068 109.736C94.2135 110.257 96.0001 111.93 95.8226 112.913C95.645 113.895 96.806 115.916 96.806 114.588C96.806 113.259 96.806 111.411 97.5218 110.66C98.2375 109.909 99.0406 109.39 99.3957 109.968C99.7536 110.545 99.5732 111.757 100.111 112.162C100.647 112.566 100.289 114.473 100.915 113.778C101.54 113.086 101.182 109.273 103.059 109.62Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 98,
    width: 62,
    height: 20
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M103.059 109.62C103.329 109.671 100.827 108.869 100.915 107.772C101.005 106.674 101.005 106.385 99.3083 105.577C97.6119 104.77 98.0572 103.903 96.0931 103.671C94.129 103.44 91.1815 103.498 90.7362 103.208C90.7362 103.208 89.6654 100.841 85.199 101.07C85.199 101.07 83.3251 98.1253 80.5551 98.5864C80.5551 98.5864 77.8752 97.7207 74.66 98.4716C71.4448 99.2224 71.2672 101.302 71.5349 102.226C71.8026 103.15 71.0897 103.554 70.2838 103.092C69.4807 102.629 69.0326 101.185 65.3722 101.763C61.7117 102.341 60.283 99.5687 56.9776 99.915C53.6722 100.261 56.5323 101.705 52.4238 101.129C48.3153 100.551 45.7256 99.8001 45.6383 101.765C45.5481 103.728 43.6742 103.671 42.6907 105.173C41.7073 106.674 41.8876 108.696 42.6907 109.273C43.4938 109.851 43.8517 116.55 44.4773 113.086C45.1029 109.621 45.1931 108.349 46.1737 108.812C47.1571 109.275 46.4414 108.524 47.8701 108.176C49.2988 107.828 52.4238 105.346 51.9786 107.54C51.5334 109.734 52.2463 114.471 52.514 112.045C52.7817 109.62 52.4238 106.097 54.2104 106.385C55.9969 106.673 58.0512 107.423 56.4422 108.984C54.836 110.544 57.6032 111.697 56.9776 112.623C56.352 113.547 57.2453 112.652 57.2453 115.656C57.2453 118.659 58.674 117.157 59.0318 108.898C59.1727 105.652 61.9794 107.252 62.1569 109.215C62.3344 111.178 63.5856 114.125 64.3887 112.738C65.1918 111.351 65.9949 105.807 66.7107 107.077C67.4264 108.347 69.3003 109.388 70.0161 108.174C70.7318 106.961 71.2672 105.863 72.2479 107.019C73.2313 108.174 71.3546 115.508 73.1411 115.393C74.9277 115.278 72.6057 110.254 74.1246 107.943C75.6435 105.632 76.8044 106.383 76.982 107.077C77.1595 107.77 77.2497 111.005 78.7685 109.966C80.2874 108.927 79.1264 106.153 80.4649 106.674C81.8034 107.194 81.8936 109.851 83.1448 109.215C84.3959 108.579 83.5026 106.326 85.0187 106.501C86.5375 106.674 86.0021 109.1 87.7859 108.349C89.5724 107.598 90.3755 105.75 91.2688 106.674C92.1621 107.598 92.6073 106.733 93.7683 107.425C94.9293 108.118 96.0001 109.215 95.1068 109.736C94.2135 110.257 96.0001 111.93 95.8226 112.913C95.645 113.895 96.806 115.916 96.806 114.588C96.806 113.259 96.806 111.411 97.5218 110.66C98.2375 109.909 99.0406 109.39 99.3957 109.968C99.7536 110.545 99.5732 111.757 100.111 112.162C100.647 112.566 100.289 114.473 100.915 113.778C101.54 113.086 101.182 109.273 103.059 109.62Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M101.72 108.379C101.72 108.379 101.275 107.974 99.8466 108.205C98.4179 108.437 97.3471 107.455 97.3471 106.531C97.3471 105.607 99.5789 104.624 97.5246 104.741C95.4703 104.856 92.7905 105.377 91.9 104.683C91.0067 103.99 89.9359 104.856 88.8651 104.395C87.7943 103.932 87.7943 102.605 85.1145 102.374C82.4346 102.142 78.684 98.4461 77.2553 100.467C75.8266 102.488 73.5948 102.547 71.5406 102.23C69.4863 101.912 73.0594 104.916 71.0052 105.435C68.9509 105.955 68.1478 103.414 65.3806 104.222C62.6134 105.031 58.7726 100.757 56.4506 102.259C54.1287 103.76 55.2897 106.186 51.8067 104.972C48.3238 103.759 47.9659 106.301 46.0018 105.377C44.0377 104.453 41.3579 103.817 40.4646 104.511C39.5713 105.204 37.1592 113.463 37.1592 113.463L51.8941 119.124L73.6822 121.376L107.168 117.272L111.186 111.787L101.72 108.379Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M103.059 108.493C102.701 108.552 100.915 108.84 101.005 110.456C101.095 112.073 100.737 110.744 100.021 109.532C99.3055 108.32 97.8768 109.013 97.3414 109.878C96.806 110.744 95.8226 111.612 95.9128 110.225C96.0029 108.838 96.1805 107.568 94.5742 107.048C92.968 106.529 92.4298 106.99 91.7169 106.182C91.0011 105.373 89.9303 105.432 88.9497 106.356C87.9662 107.28 87.8789 107.743 86.7179 106.356C85.5569 104.969 83.1448 107.106 82.074 106.587C81.0032 106.068 81.8063 104.854 83.6802 104.854C85.5541 104.854 85.8246 104.508 87.0729 104.739C88.3213 104.971 88.4115 103.469 86.8954 103.584C85.3766 103.698 83.6802 103.525 83.2349 102.891C82.7897 102.255 80.3776 100.928 79.1264 102.025C77.8753 103.123 78.8587 104.509 77.3399 104.336C75.821 104.163 74.7502 108.552 73.0538 106.531C71.3574 104.509 70.0189 108.493 68.5001 107.396C66.9812 106.299 65.1946 105.202 64.6592 107.569C64.1238 109.937 63.766 110.573 62.8727 107.916C61.9794 105.258 59.8378 107.857 58.4965 106.992C57.1579 106.126 54.3879 105.258 53.1396 105.836C51.8884 106.414 50.8176 105.2 49.5665 106.124C48.3153 107.048 47.1543 108.954 45.6383 107.857C44.1194 106.76 42.6908 108.262 43.3163 106.702C43.9419 105.142 41.0845 104.218 42.423 103.411C43.7616 102.601 36.7083 106.992 36.7083 106.992L34.7442 115.366L52.159 123.048L89.0399 120.968L110.115 118.601L103.059 108.493Z",
    fill: "url(#paint5_linear_2436_51438)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2436_51438)"
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M114.609 109.159C114.845 109.21 112.658 108.408 112.734 107.311C112.813 106.214 112.813 105.924 111.33 105.117C109.847 104.309 110.236 103.442 108.519 103.21C106.802 102.979 104.225 103.037 103.836 102.747C103.836 102.747 102.899 100.38 98.9947 100.61C98.9947 100.61 97.3565 97.6645 94.9348 98.1256C94.9348 98.1256 92.5919 97.26 89.781 98.0108C86.97 98.7617 86.8148 100.841 87.0489 101.765C87.2829 102.689 86.6596 103.094 85.9551 102.631C85.2529 102.168 84.8612 100.724 81.6611 101.302C78.4609 101.88 77.2119 99.1079 74.3221 99.4542C71.4323 99.8005 73.9328 101.244 70.341 100.668C66.7491 100.09 64.4851 99.3394 64.4087 101.304C64.3299 103.267 62.6916 103.21 61.8318 104.712C60.972 106.214 61.1297 108.235 61.8318 108.813C62.5339 109.39 62.8468 116.09 63.3937 112.625C63.9406 109.161 64.0194 107.889 64.8768 108.351C65.7366 108.814 65.1108 108.064 66.3598 107.715C67.6089 107.367 70.341 104.885 69.9517 107.079C69.5625 109.274 70.1858 114.01 70.4198 111.585C70.6538 109.159 70.341 105.636 71.9029 105.924C73.4648 106.212 75.2607 106.963 73.854 108.523C72.4498 110.083 74.869 111.236 74.3221 112.162C73.7752 113.086 74.5561 112.191 74.5561 115.195C74.5561 118.198 75.8052 116.697 76.118 108.437C76.2412 105.191 78.6949 106.791 78.8501 108.754C79.0053 110.717 80.0992 113.664 80.8013 112.277C81.5034 110.89 82.2055 105.346 82.8313 106.616C83.457 107.887 85.0953 108.927 85.721 107.714C86.3468 106.5 86.8148 105.403 87.6722 106.558C88.532 107.714 86.8912 115.047 88.4531 114.932C90.015 114.818 87.985 109.793 89.3129 107.482C90.6408 105.171 91.6558 105.922 91.811 106.616C91.9662 107.309 92.045 110.544 93.3729 109.505C94.7007 108.466 93.6857 105.692 94.8559 106.214C96.0261 106.733 96.105 109.39 97.1988 108.754C98.2926 108.118 97.5117 105.866 98.8371 106.041C100.165 106.214 99.6968 108.639 101.256 107.889C102.818 107.138 103.52 105.29 104.301 106.214C105.082 107.138 105.471 106.272 106.486 106.965C107.501 107.657 108.438 108.754 107.657 109.275C106.876 109.797 108.438 111.47 108.282 112.452C108.127 113.434 109.142 115.455 109.142 114.127C109.142 112.798 109.142 110.95 109.768 110.199C110.394 109.449 111.096 108.929 111.406 109.507C111.719 110.085 111.561 111.297 112.032 111.701C112.5 112.106 112.187 114.012 112.734 113.318C113.281 112.625 112.968 108.813 114.609 109.159Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 97,
    width: 54,
    height: 20
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M114.609 109.159C114.845 109.21 112.658 108.408 112.734 107.311C112.813 106.214 112.813 105.924 111.33 105.117C109.847 104.309 110.236 103.442 108.519 103.21C106.802 102.979 104.225 103.037 103.836 102.747C103.836 102.747 102.899 100.38 98.9947 100.61C98.9947 100.61 97.3565 97.6645 94.9348 98.1256C94.9348 98.1256 92.5919 97.26 89.781 98.0108C86.97 98.7617 86.8148 100.841 87.0489 101.765C87.2829 102.689 86.6596 103.094 85.9551 102.631C85.2529 102.168 84.8612 100.724 81.6611 101.302C78.4609 101.88 77.2119 99.1079 74.3221 99.4542C71.4323 99.8005 73.9328 101.244 70.341 100.668C66.7491 100.09 64.4851 99.3394 64.4087 101.304C64.3299 103.267 62.6916 103.21 61.8318 104.712C60.972 106.214 61.1297 108.235 61.8318 108.813C62.5339 109.39 62.8468 116.09 63.3937 112.625C63.9406 109.161 64.0194 107.889 64.8768 108.351C65.7366 108.814 65.1108 108.064 66.3598 107.715C67.6089 107.367 70.341 104.885 69.9517 107.079C69.5625 109.274 70.1858 114.01 70.4198 111.585C70.6538 109.159 70.341 105.636 71.9029 105.924C73.4648 106.212 75.2607 106.963 73.854 108.523C72.4498 110.083 74.869 111.236 74.3221 112.162C73.7752 113.086 74.5561 112.191 74.5561 115.195C74.5561 118.198 75.8052 116.697 76.118 108.437C76.2412 105.191 78.6949 106.791 78.8501 108.754C79.0053 110.717 80.0992 113.664 80.8013 112.277C81.5034 110.89 82.2055 105.346 82.8313 106.616C83.457 107.887 85.0953 108.927 85.721 107.714C86.3468 106.5 86.8148 105.403 87.6722 106.558C88.532 107.714 86.8912 115.047 88.4531 114.932C90.015 114.818 87.985 109.793 89.3129 107.482C90.6408 105.171 91.6558 105.922 91.811 106.616C91.9662 107.309 92.045 110.544 93.3729 109.505C94.7007 108.466 93.6857 105.692 94.8559 106.214C96.0261 106.733 96.105 109.39 97.1988 108.754C98.2926 108.118 97.5117 105.866 98.8371 106.041C100.165 106.214 99.6968 108.639 101.256 107.889C102.818 107.138 103.52 105.29 104.301 106.214C105.082 107.138 105.471 106.272 106.486 106.965C107.501 107.657 108.438 108.754 107.657 109.275C106.876 109.797 108.438 111.47 108.282 112.452C108.127 113.434 109.142 115.455 109.142 114.127C109.142 112.798 109.142 110.95 109.768 110.199C110.394 109.449 111.096 108.929 111.406 109.507C111.719 110.085 111.561 111.297 112.032 111.701C112.5 112.106 112.187 114.012 112.734 113.318C113.281 112.625 112.968 108.813 114.609 109.159Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M113.439 107.918C113.439 107.918 113.049 107.513 111.8 107.745C110.551 107.976 109.615 106.994 109.615 106.07C109.615 105.146 111.566 104.164 109.77 104.28C107.974 104.395 105.632 104.916 104.853 104.222C104.072 103.529 103.136 104.395 102.2 103.934C101.264 103.471 101.264 102.144 98.9208 101.913C96.578 101.681 93.2989 97.9854 92.0499 100.007C90.8009 102.028 88.8497 102.086 87.0538 101.769C85.2579 101.452 88.3817 104.455 86.5857 104.975C84.7898 105.494 84.0877 102.953 81.6684 103.761C79.2492 104.57 75.8914 100.296 73.8614 101.798C71.8314 103.3 72.8464 105.725 69.8014 104.512C66.7565 103.298 66.4436 105.84 64.7265 104.916C63.0094 103.992 60.6665 103.356 59.8856 104.051C59.1046 104.743 56.9958 113.002 56.9958 113.002L69.8778 118.663L88.9261 120.916L118.201 116.811L121.714 111.326L113.439 107.918Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M114.609 108.033C114.296 108.091 112.734 108.379 112.813 109.995C112.892 111.612 112.579 110.283 111.953 109.071C111.327 107.859 110.078 108.552 109.61 109.418C109.142 110.283 108.282 111.151 108.361 109.764C108.44 108.377 108.595 107.107 107.191 106.587C105.787 106.068 105.316 106.529 104.693 105.722C104.067 104.913 103.131 104.971 102.274 105.895C101.414 106.819 101.338 107.282 100.323 105.895C99.3076 104.508 97.1988 106.646 96.2626 106.126C95.3265 105.607 96.0286 104.393 97.6669 104.393C99.3051 104.393 99.5416 104.047 100.633 104.278C101.724 104.51 101.803 103.008 100.478 103.123C99.1499 103.238 97.6669 103.065 97.2776 102.43C96.8884 101.794 94.7796 100.468 93.6857 101.565C92.5919 102.662 93.4517 104.049 92.1238 103.876C90.796 103.702 89.8598 108.091 88.3767 106.07C86.8937 104.049 85.7235 108.033 84.3956 106.935C83.0678 105.838 81.5058 104.741 81.0378 107.109C80.5697 109.476 80.2568 110.112 79.4759 107.455C78.6949 104.798 76.8226 107.397 75.6499 106.531C74.4798 105.665 72.0581 104.798 70.9667 105.375C69.8729 105.953 68.9367 104.739 67.8429 105.663C66.7491 106.587 65.7341 108.494 64.4087 107.397C63.0808 106.299 61.8318 107.801 62.3787 106.241C62.9256 104.681 60.4276 103.757 61.5978 102.95C62.7679 102.141 56.6016 106.531 56.6016 106.531L54.8845 114.905L70.1094 122.587L102.353 120.507L120.778 118.14L114.609 108.033Z",
    fill: "url(#paint6_linear_2436_51438)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2436_51438)"
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6445 109.159C13.408 109.21 15.5956 108.408 15.5193 107.311C15.4404 106.214 15.4404 105.924 16.9235 105.117C18.4066 104.309 18.0173 103.442 19.7344 103.21C21.4515 102.979 24.0284 103.037 24.4177 102.747C24.4177 102.747 25.3538 100.38 29.2586 100.61C29.2586 100.61 30.8968 97.6645 33.3185 98.1256C33.3185 98.1256 35.6614 97.26 38.4723 98.0108C41.2832 98.7617 41.4385 100.841 41.2044 101.765C40.9704 102.689 41.5937 103.094 42.2982 102.631C43.0004 102.168 43.3921 100.724 46.5922 101.302C49.7924 101.88 51.0414 99.1079 53.9312 99.4542C56.821 99.8005 54.3204 101.244 57.9123 100.668C61.5042 100.09 63.7682 99.3394 63.8446 101.304C63.9234 103.267 65.5617 103.21 66.4215 104.712C67.2813 106.214 67.1236 108.235 66.4215 108.813C65.7194 109.39 65.4065 116.09 64.8596 112.625C64.3127 109.161 64.2338 107.889 63.3765 108.351C62.5167 108.814 63.1425 108.064 61.8935 107.715C60.6444 107.367 57.9123 104.885 58.3016 107.079C58.6908 109.274 58.0675 114.01 57.8335 111.585C57.5995 109.159 57.9123 105.636 56.3504 105.924C54.7885 106.212 52.9926 106.963 54.3993 108.523C55.8035 110.083 53.3843 111.236 53.9312 112.162C54.4781 113.086 53.6972 112.191 53.6972 115.195C53.6972 118.198 52.4481 116.697 52.1353 108.437C52.0121 105.191 49.5584 106.791 49.4032 108.754C49.248 110.717 48.1541 113.664 47.452 112.277C46.7499 110.89 46.0478 105.346 45.422 106.616C44.7963 107.887 43.158 108.927 42.5323 107.714C41.9065 106.5 41.4385 105.403 40.5811 106.558C39.7213 107.714 41.3621 115.047 39.8002 114.932C38.2383 114.818 40.2683 109.793 38.9404 107.482C37.6125 105.171 36.5975 105.922 36.4423 106.616C36.2871 107.309 36.2083 110.544 34.8804 109.505C33.5526 108.466 34.5676 105.692 33.3974 106.214C32.2272 106.733 32.1483 109.39 31.0545 108.754C29.9607 108.118 30.7416 105.866 29.4162 106.041C28.0884 106.214 28.5565 108.639 26.997 107.889C25.4351 107.138 24.733 105.29 23.952 106.214C23.1711 107.138 22.7819 106.272 21.7669 106.965C20.7519 107.657 19.8157 108.754 20.5967 109.275C21.3776 109.797 19.8157 111.47 19.9709 112.452C20.1261 113.434 19.1111 115.455 19.1111 114.127C19.1111 112.798 19.1111 110.95 18.4854 110.199C17.8596 109.449 17.1575 108.929 16.8471 109.507C16.5342 110.085 16.6919 111.297 16.2214 111.701C15.7533 112.106 16.0662 114.012 15.5193 113.318C14.9723 112.625 15.2852 108.813 13.6445 109.159Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_2436_51438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 97,
    width: 55,
    height: 20
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6445 109.159C13.408 109.21 15.5956 108.408 15.5193 107.311C15.4404 106.214 15.4404 105.924 16.9235 105.117C18.4066 104.309 18.0173 103.442 19.7344 103.21C21.4515 102.979 24.0284 103.037 24.4177 102.747C24.4177 102.747 25.3538 100.38 29.2586 100.61C29.2586 100.61 30.8968 97.6645 33.3185 98.1256C33.3185 98.1256 35.6614 97.26 38.4723 98.0108C41.2832 98.7617 41.4385 100.841 41.2044 101.765C40.9704 102.689 41.5937 103.094 42.2982 102.631C43.0004 102.168 43.3921 100.724 46.5922 101.302C49.7924 101.88 51.0414 99.1079 53.9312 99.4542C56.821 99.8005 54.3204 101.244 57.9123 100.668C61.5042 100.09 63.7682 99.3394 63.8446 101.304C63.9234 103.267 65.5617 103.21 66.4215 104.712C67.2813 106.214 67.1236 108.235 66.4215 108.813C65.7194 109.39 65.4065 116.09 64.8596 112.625C64.3127 109.161 64.2338 107.889 63.3765 108.351C62.5167 108.814 63.1425 108.064 61.8935 107.715C60.6444 107.367 57.9123 104.885 58.3016 107.079C58.6908 109.274 58.0675 114.01 57.8335 111.585C57.5995 109.159 57.9123 105.636 56.3504 105.924C54.7885 106.212 52.9926 106.963 54.3993 108.523C55.8035 110.083 53.3843 111.236 53.9312 112.162C54.4781 113.086 53.6972 112.191 53.6972 115.195C53.6972 118.198 52.4481 116.697 52.1353 108.437C52.0121 105.191 49.5584 106.791 49.4032 108.754C49.248 110.717 48.1541 113.664 47.452 112.277C46.7499 110.89 46.0478 105.346 45.422 106.616C44.7963 107.887 43.158 108.927 42.5323 107.714C41.9065 106.5 41.4385 105.403 40.5811 106.558C39.7213 107.714 41.3621 115.047 39.8002 114.932C38.2383 114.818 40.2683 109.793 38.9404 107.482C37.6125 105.171 36.5975 105.922 36.4423 106.616C36.2871 107.309 36.2083 110.544 34.8804 109.505C33.5526 108.466 34.5676 105.692 33.3974 106.214C32.2272 106.733 32.1483 109.39 31.0545 108.754C29.9607 108.118 30.7416 105.866 29.4162 106.041C28.0884 106.214 28.5565 108.639 26.997 107.889C25.4351 107.138 24.733 105.29 23.952 106.214C23.1711 107.138 22.7819 106.272 21.7669 106.965C20.7519 107.657 19.8157 108.754 20.5967 109.275C21.3776 109.797 19.8157 111.47 19.9709 112.452C20.1261 113.434 19.1111 115.455 19.1111 114.127C19.1111 112.798 19.1111 110.95 18.4854 110.199C17.8596 109.449 17.1575 108.929 16.8471 109.507C16.5342 110.085 16.6919 111.297 16.2214 111.701C15.7533 112.106 16.0662 114.012 15.5193 113.318C14.9723 112.625 15.2852 108.813 13.6445 109.159Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_2436_51438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M14.8147 107.918C14.8147 107.918 15.2039 107.513 16.453 107.745C17.702 107.976 18.6381 106.994 18.6381 106.07C18.6381 105.146 16.687 104.164 18.4829 104.28C20.2789 104.395 22.6217 104.916 23.4002 104.222C24.1812 103.529 25.1173 104.395 26.0535 103.934C26.9896 103.471 26.9896 102.144 29.3325 101.913C31.6753 101.681 34.9544 97.9854 36.2034 100.007C37.4524 102.028 39.4036 102.086 41.1995 101.769C42.9954 101.452 39.8716 104.455 41.6676 104.975C43.4635 105.494 44.1656 102.953 46.5849 103.761C49.0041 104.57 52.3619 100.296 54.3919 101.798C56.4219 103.3 55.4069 105.725 58.4519 104.512C61.4968 103.298 61.8097 105.84 63.5268 104.916C65.2439 103.992 67.5868 103.356 68.3677 104.051C69.1487 104.743 71.2575 113.002 71.2575 113.002L58.3755 118.663L39.3272 120.916L10.0526 116.811L6.53955 111.326L14.8147 107.918Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M13.6445 108.033C13.9574 108.091 15.5193 108.379 15.4404 109.995C15.3616 111.612 15.6745 110.283 16.3002 109.071C16.926 107.859 18.175 108.552 18.6431 109.418C19.1111 110.283 19.9709 111.151 19.8921 109.764C19.8133 108.377 19.6581 107.107 21.0623 106.587C22.4665 106.068 22.9371 106.529 23.5603 105.722C24.1861 104.913 25.1222 104.971 25.9796 105.895C26.8394 106.819 26.9157 107.282 27.9307 105.895C28.9457 104.508 31.0545 106.646 31.9907 106.126C32.9268 105.607 32.2247 104.393 30.5864 104.393C28.9482 104.393 28.7117 104.047 27.6203 104.278C26.5289 104.51 26.4501 103.008 27.7755 103.123C29.1034 103.238 30.5864 103.065 30.9757 102.43C31.3649 101.794 33.4737 100.468 34.5676 101.565C35.6614 102.662 34.8016 104.049 36.1295 103.876C37.4573 103.702 38.3935 108.091 39.8766 106.07C41.3596 104.049 42.5298 108.033 43.8577 106.935C45.1855 105.838 46.7474 104.741 47.2155 107.109C47.6836 109.476 47.9965 110.112 48.7774 107.455C49.5584 104.798 51.4307 107.397 52.6033 106.531C53.7735 105.665 56.1952 104.798 57.2866 105.375C58.3804 105.953 59.3166 104.739 60.4104 105.663C61.5042 106.587 62.5192 108.494 63.8446 107.397C65.1725 106.299 66.4215 107.801 65.8746 106.241C65.3277 104.681 67.8257 103.757 66.6555 102.95C65.4853 102.141 71.6517 106.531 71.6517 106.531L73.3688 114.905L58.1439 122.587L25.9007 120.507L7.47571 118.14L13.6445 108.033Z",
    fill: "url(#paint7_linear_2436_51438)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2436_51438",
    x1: 48.1157,
    y1: 54.2947,
    x2: 71.4372,
    y2: 46.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2151B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2151B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2436_51438",
    x1: 46.0765,
    y1: 23.4893,
    x2: 54.1789,
    y2: 31.1712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2436_51438",
    x1: 62.598,
    y1: 109.101,
    x2: 25.5895,
    y2: 109.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2436_51438",
    x1: 117.439,
    y1: 107.258,
    x2: 42.068,
    y2: 107.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2436_51438",
    x1: 191.006,
    y1: 111.993,
    x2: 106.609,
    y2: 111.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2436_51438",
    x1: 110.115,
    y1: 112.326,
    x2: 34.7442,
    y2: 112.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2436_51438",
    x1: 120.778,
    y1: 111.865,
    x2: 54.8845,
    y2: 111.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2436_51438",
    x1: 7.47571,
    y1: 111.865,
    x2: 73.3688,
    y2: 111.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 106,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4604,
    height: 24.8803,
    fill: "white",
    transform: "matrix(-1 0 0 1 58.4899 94.9421)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.1815,
    height: 24.8803,
    fill: "white",
    transform: "matrix(-1 0 0 1 109.34 93.0991)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.5865,
    height: 26.7232,
    fill: "white",
    transform: "matrix(-1 0 0 1 177 96.7851)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.1815,
    height: 24.8803,
    fill: "white",
    transform: "matrix(-1 0 0 1 102.616 98.1673)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.3563,
    height: 24.8803,
    fill: "white",
    transform: "matrix(-1 0 0 1 112.282 97.7065)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2436_51438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.3563,
    height: 24.8803,
    fill: "white",
    transform: "translate(6.53955 97.7065)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowMan);
export default __webpack_public_path__ + "static/media/snow-man.4a6e8940640a69660246aea8683410af.svg";
export { ForwardRef as ReactComponent };